/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import React, { Component, createRef, forwardRef, useState } from 'react';
import { Button, Row, Col, Container, Form, Modal, Spinner, Dropdown, FormControl,ProgressBar } from 'react-bootstrap';

import { toast as defaultToast, cssTransition } from 'react-toastify';
import { PinturaEditor } from 'react-pintura';
// import { DokaImageEditor } from 'react-doka';
import ReactQuill from 'react-quill';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import heic2any from "heic2any";

// project imports
import { getSellerUrl, getSellerHeaders, getBuyerHeaders, getBuyerUrl } from 'shared/http';
import { setEditorPlugins, getEditorDefaults, IMAGE_OUTPUT_QUALITY } from 'shared/pintura/pintura';
import { processImage, createDefaultImageReader, createDefaultImageWriter,blobToFile } from 'doka';
// import { setEditorPlugins, IMAGE_OUTPUT_QUALITY, getEditorDefaults } from 'shared/pintura/pintura';
// import { processImage, createDefaultImageReader, createDefaultImageWriter } from 'pintura';
import { allWordsInCaps, ArrayValueReorder } from 'shared/modifiers';
import { IMAGE_TYPES, VIDEO_TYPES, CATERGORY } from 'shared/settings/config';
// import { HelpSideBar } from './../layouts/HelpSidebar';
import {
    itemadd, itemdetail, itemimageadd,
    itemimagedelete, itemimagelist, itemimageupdate,
    itemupdate, locationlist, salelist, skugenerate, saledetail,
    fileUpload, fileUploadFragment, items, roomslist, roomsMappingList, bid_history, secret_key,
    conditionData
} from 'shared/settings/apiconfig';
import Validators from 'shared/validators';
// import toast from 'shared/toast';
import { ToasterMessage } from 'shared/toast/toast';
import AREA from 'features/constants/Area';
import ReorderImages from './ItemsImageReorder'; 
import FileType from "file-type/browser";
import imageCompression from 'browser-image-compression';


// style imports
// import 'doka/doka.css';
import 'pintura/pintura.css';
import './ItemsEdit.scss';

import { ExtendSnowTheme } from 'shared/editor/quill-editor';
import { getBase64Content } from 'shared/utils/utils';
import { NoData } from 'features/components/redirect/NoData';
import moment from 'moment';

/* initializes doka editing plugins */
setEditorPlugins();

// item constant values
const step = { 1: 'detail', 2: 'settings', 3: 'media' };
const decimalTypes = ['startingprice', 'reserveprice', 'buynowprice', 'buyerspremium', 'tax', 'width', 'height', 'length', 'weight', 'shippingfee', 'handlingfee', 'goal', 'valuation'];
const priceValidation = ['reserveprice', 'buynowprice', 'goal', 'valuation', 'startingprice'];

/**
 * this page is used to edit and create items
 * 
 * @param props
 * 
 * @param itemid
 * 
 * @return html to render items edit or create
 * 
**/


const CustomToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        className="form-control custom-drop-down"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
        id="DisableSale"
    >
        {children}
        <img src={`${process.env.PUBLIC_URL}/static/media/arrow.984f931e.svg`} alt="drop-down"></img>
        {/* &#x25bc; */}
    </div>
));



const quillAllowedRegexPattern =/^[A-Za-z0-9 .,!#\$%&\*\(\)\-\/'"\+\?<>\_\[\]:;@“”`‘’]+$/;
export class ItemsEdit extends Component {
    locations;
    category;
    edit;
    itemId;
    sales;
    selectedSaleId;
    editImageIndex;
    deleteImageId;
    displayImageId;
    mediaImageValue;
    mediaDisplayImageId;
    reorderImageIds;
    uploadedImage;
    prevPath;
    viewModal;
    viewModalName;
    editModalName;
    templateEditValue;
    isCallFromSale;
    TotalAreaList = []
    areaArray = [];
    dokaConvertedImage = [];
    videoCount = 0;
    imageaddCount = 0;
    uploadedVideoCount = 0;
    percentage = 0;
    variant = 'info';
    progresseLabel = '';
    uploadCount = 0; 

    mediaStatus; // current status of each image/video processed or not when clicking save
    mediaProcessed;
    imageProcessed;
    isSaveMediaError;
    dokaConvertedImage;
    customEditorDefaults;
    largeFiles = [];
    heicfile ='';
    totalMediaAllowed = 40;
    errorFileList = [];
    modules = {
        toolbar: [
            ['underline'], 
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['link'],
            ['clean']
        ],
        clipboard: {
            matchVisual: false,
            matchers: [
                ["span", (node, delta) => {
                  delta.ops.forEach((op) => {
                    if (op.attributes) {
                      const isLink = !!op.attributes.link;
                      Object.keys(op.attributes).forEach((attr) => {
                        if (attr !== "link") delete op.attributes[attr]; 
                      });
                      if (!isLink) delete op.attributes.color;
                      delete op.attributes.background;
                    }
                  });
                  return delta;
                }],
                [Node.ELEMENT_NODE, (node, delta) => {
                  const blocked = [
                    "bold",
                    "italic",
                    "strike",
                    "size",
                    "font",
                    "header",
                    "color",
                    "background",
                  ];
                  delta.ops.forEach((op) => {
                    if (op.attributes) {
                      blocked.forEach((attr) => delete op.attributes[attr]);
                    }
                  });
                  return delta;
                }],
               
                ["a", (node, delta) => delta],
            ],
        },
        magicUrl: true,
        keyboard: {
            bindings: {
                // Disable Ctrl+B
                bold: { key: "B", shortKey: true, handler: () => false },
                // Disable Ctrl+I
                italic: { key: "I", shortKey: true, handler: () => false },
            }
        }
    };
    
    constructor(props) {
        super(props);
        this.textEditorRef = null;
        this.searchRef = createRef();
        /* check for create or edit sale */
        this.itemId = this.props.location.pathname.slice(this.props.location.pathname.lastIndexOf('/') + 1);
        if (isNaN(Number(this.itemId))) {
            this.edit = true;
        }
        this.prevPath = this.props.location.state ? this.props.location.state.prevPath ? this.props.location.state.prevPath : items : items;
        if (this.prevPath === items)
            this.isCallFromSale = true;
        this.TOAST_CONFIG = {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            pauseOnFocusLoss: false,
            transition: cssTransition({ duration: 300, enter: 'zoomIn', exit: 'zoomOut' })
        }
        this.state = {
            itemTypeError: false,
            currentPage: 1,
            chars_left: 500, 
            formLoading: true,
            loading: false,
            itemid: this.edit ? null : this.itemId,
            tempSale: [],
            sales: [],
            showConfirmModal: false,
            prevPath: this.prevPath,
            disableSalesList: false,
            uploadImageSize:5,
            saleLevelIrm: '',
            itemLevelIrm: '',
            irmvalid: false,
            itemStatusValid : this.edit ? true : false,
            detail: {
                locationid: { value: '', valid: false, error: '', validators: [Validators.required()] },
                saleid: { value: '', valid: false, error: '', validators: [Validators.required()] },
                category: { value: '', valid: false, error: '', validators: [Validators.required()] },
                area: { value: '', error: '', valid: true, validators: [Validators.maxLength(30)] },
                title: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxLength(100)] },
                SKU: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.maxLength(20)] },
                condition: { value: '', error: '', valid: false, validators: [Validators.required()]},
                description: { value: '', error: '', valid: false },
                itemstatus: {value: this.edit ? 'Pending': '', error: '', valid: false, validators: [Validators.required(), Validators.maxLength(25)] },
                categoryGroup: { value: '', error: '', valid: false },
                viewModal: false,
                editModal: false,
                formValid: false
            },
            settings: {
                isshippable: { value: false, error: '', valid: true },
                isfeatured: { value: false, error: '', valid: true },
                istaxable: { value: false, error: '', valid: true },
                startingprice: { value: '1', error: '', valid: true, validators: [Validators.maxDigit(10)] },
                reserveprice: { value: '', error: '', valid: true, validators: [Validators.maxDigit(10)] },
                buynowprice: { value: '', error: '', valid: true, validators: [Validators.maxDigit(10)] },
                buyerspremium: { value: '', error: '', valid: true, validators: [Validators.maxDigit(3)] },
                width: { value: '', error: '', valid: true, validators: [Validators.maxDigit(4)] },
                height: { value: '', error: '', valid: true, validators: [Validators.maxDigit(4)] },
                length: { value: '', error: '', valid: true, validators: [Validators.maxDigit(4)] },
                weight: { value: '', error: '', valid: true, validators: [Validators.maxDigit(4)] },
                shippingfee: { value: '', error: '', valid: true, validators: [Validators.maxDigit(10)] },
                handlingfee: { value: '', error: '', valid: true, validators: [Validators.maxDigit(10)] },
                itemtypeid: { value: '2', error: '', valid: false, validators: [Validators.required()] },
                goal: { value: '', error: '', valid: true, validators: [Validators.maxDigit(10)] },
                valuation: { value: '', error: '', valid: true, validators: [Validators.maxDigit(10)] },
                itemreceiptmethod : { value: {}, valid: false, error: '', validators: [Validators.required()] },
                tax: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxDigit(3)] },
                tag: { value: [], error: '', valid: true },
                fragilityscore: { value: null, error: '', valid: true },
                quantity: { value: '', error: '', valid: true },
                material: { value: null, error: '', valid: true },
                specialtyshippeditems: { value: '', error: '', valid: true },
                formValid: false
            },
            media: {
                image: { value: [], tempValue: [], imgValue: [], error: '', imgCount: null, isDokaConverted: false, type: '' },
                temImg: null,
                deleteAllImage: false,
                enableSave: false,
                modal: false,
                video: { modal: -1 }
            },
            isEdit: false,
            errorpageredirect: false,
            formValid: false,
            showReorder: true,
            disableButton: false,
            tagValue: null,
            itemStatus: { show: false, type: '', message: '' },
            searchInput: null,
            showSearchBox: false,
            isitemEdit:false,
            // checkPointMessage: '',
            checkPointModal: false,
            itemCheckStatus: { show: false, type: '', message: '' },
            closingorder: 999, // For Closing order default value is 999
            currentBid: null,
            bidderCount: 0,
            bid_history: [],
            showItemType: true,
            invalidIrm: [],
            conditionData: [],
            openMediaDialogModal: false,
            dialogModalMessage: false,
            modalMessage: { show: false, type: '', message: '' },
            errorType: ''
        }
        this.viewModal = false;
        this.viewModalName = '';
        this.editModalName = '';
        this.templateEditValue = '';
        this.locations = [];
        this.category = [];
        this.sales = [];
        this.editImageIndex = null;
        this.deleteImageId = [];
        this.dokaConvertedImage = [];
        this.errorToasterId = "";
        this.displayImageId = null;
        this.mediaImageValue = [];
        this.mediaDisplayImageId = null;
        this.reorderImageIds = [];
        this.uploadedImage = [];
        this.mediaStatus = {};
        this.mediaProcessed = 0;
        this.imageProcessed = 0;
        this.isSaveMediaError = false;
        this.TotalAreaList = []
        this.areaArray = [];
        this.selectedSaleId = '';
        if (!this.isCallFromSale && this.edit) {
            this.getSaleLocation();
        }
        this.customEditorDefaults = {
            cropEnableSelectPreset: false,
            layoutDirectionPreference: 'vertical'
        };
        this.selectedSale = [];
        this.approveBack = false;
        this.chunks = [];
        this.timeoutInterval = {};
        
    }

    componentDidMount() {
        this.getSecretKey();
        
      
        if (this.edit) {
            let previousSaletitle = localStorage.getItem('previousSaleId');
            if (previousSaletitle !== null) {
                this.previousSaletitle = previousSaletitle

            }
        }
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
      
    }

    componentWillUnmount() {
        if(this.props.location?.state?.state?.name === 'Saledashboard'){
        }
        else{
             window.removeEventListener('popstate', this.onBack);      
        }    
    }

    getSaleDetails() {
        axios.post(getSellerUrl(`${saledetail}/${this.state.detail.saleid.value}`), JSON.stringify({ field: ['isshippable','salestaffcheckpoint','salestaffcheckpointid','saleitemreceiptmethod'] }), getSellerHeaders())
        .then(response => {
            if (response.data.data.length) {
                if (this.edit) {
                    this.selectedSaleId = response.data.data[0]['id'];
                    this.setState({
                      saleLevelIrm:  response.data.data[0]['saleitemreceiptmethod'],
                      formLoading: false 
                    });
                }
                this.setItemReceiptMethod(response.data.data[0]['saleitemreceiptmethod']);
                this.disableInvalidIrm(response.data.data[0]['saleitemreceiptmethod']);
            }
        })
        .catch(error => {
            // toast.error(error.response.data['message']);
            this.setState({
                ...this.state,
                formLoading: false,
            });
        });
    }

    cancelCheckPoint () {
        this.setState({
            ...this.state,
            formLoading: false,
            itemCheckStatus: { show: true, type: 'danger', message: 'Please review your item' }
        },()=> {
            setTimeout(() => {
                this.setState({
                    itemCheckStatus: { show: false, type: '', message: '' },
                    checkPointModal: false
                })
            }, 3000);
        });
    }

    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.navigateToList();
        }
    }

    // forwardRef again here!
    // Dropdown needs access to the DOM of the Menu to measure it
    CustomMenu = React.forwardRef(
        ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
            return (
                <div
                    ref={ref}
                    style={style}
                    className={`${className} w-100`}
                    aria-labelledby={labeledBy}
                >
                    {
                        this.state.showSearchBox ?
                            <FormControl
                                autoFocus
                                className="mx-auto mt-2 w-95 border-normal"
                                placeholder="Type to filter..."
                                onChange={(e) => { this.searchSaleList(e.target.value) }}
                                value={this.state.searchInput}
                                ref={this.searchRef}
                                disabled={!this.state.detail.locationid.value}
                            /> : <div className="text-center my-2">Loading...</div>
                    }
                    {
                        this.state.showSearchBox && !this.state.detail.locationid.value ?
                            <div className="mx-auto w-95 text-danger"><small>Please select location</small></div> : null

                    }
                    {
                        this.state.showSearchBox ?
                            <ul className="list-unstyled">
                                {React.Children.toArray(children).filter(
                                    (child) => child
                                )}
                            </ul> : null
                    }
                </div>
            );
        },
    );

    getRoomsList = () => {
        axios.get(getSellerUrl(roomslist), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.areaArray = Object.keys(response.data.data);
                }
            })
            .catch(error => {
            });
    }

    /* Get rooms list */
    getCategoryAreaMapList = () => {
        axios.get(getSellerUrl(roomsMappingList), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.TotalAreaList = response.data.data.data;
                }
            })
            .catch(error => {
            });
    }
    /* Get location id for sale form dashboard */
    getSaleLocation = async () => {
        let saleId = this.state.detail.saleid.value ? this.state.detail.saleid.value : Number(this.state.prevPath.slice(this.state.prevPath.lastIndexOf('/') + 1));
        await axios.post(getSellerUrl(`${saledetail}/${saleId}`), JSON.stringify({ field: ['id', 'locationid', 'status', 'title', 'tax', 'buyerspremium', 'saleitemreceiptmethod','endtime','timezonename'] }), getSellerHeaders())
            .then(response => {

                if (response.data.data.length) {
                    this.setState({  endtime: new Date(moment.tz(response.data.data[0]['endtime'], response.data.data[0]['timezonename']).local())});
                    this.disableInvalidIrm(response.data.data[0]['saleitemreceiptmethod']);

                    if (this.itemId) {
                        this.selectedSaleId = response.data.data[0]['id'];
                        this.selectedSale = [response.data.data[0]]
                        this.setState({
                            saleLevelIrm: response.data.data[0]['saleitemreceiptmethod'],
                            formLoading: false,
                            disableSalesList: true,
                            detail: {
                                ...this.state.detail,
                                locationid: {
                                    ...this.state.detail.locationid,
                                    value: response.data.data[0]['locationid'],
                                    valid: true
                                },
                                saleid: {
                                    ...this.state.detail.saleid,
                                    value: this.selectedSale[0]['id'],
                                    valid: true
                                }
                            },
                            sales: [response.data.data[0]],
                            tempSale: this.selectedSale
                        }, () => {
                            this.addTaxValidation();
                            this.setItemReceiptMethod(JSON.stringify(this.state.settings.itemreceiptmethod.value));
                            // this.getLocationSaleList(true, true);
                            if(this.edit){
                                this.generateSKU();
                                this.setBuyerTax(this.state.detail.saleid.value);
                                this.getSaleDetails(this.state.detail.saleid.value)
                            }
                        });


                        /*Handle sale Dropdown for Admin*/
                        if (this.state.detail.itemstatus.value.toLowerCase() === "pending") {
                            document.getElementById("DisableSale").style.pointerEvents = "auto"
                            document.getElementById("DisableSale").style.opacity = 1
                            this.setState({
                                formLoading: false,
                                disableSalesList: false
                            }, () => {
                                this.addTaxValidation();
                            });
                        }
                        else {
                            document.getElementById("DisableSale").style.pointerEvents = "none"
                            document.getElementById("DisableSale").style.opacity = 0.4
                            this.setState({
                                formLoading: false,
                                disableSalesList: true
                            }, () => {
                                this.addTaxValidation();
                            });
                        }
                    }
                    else {
                        let disable = this.state.disableSalesList;
                        if (this.state.detail.itemstatus.value.toLowerCase() === "pending") {
                            disable = false;
                            this.setState({
                                saleLevelIrm: response.data.data[0]['saleitemreceiptmethod'],
                                formLoading: false,
                                disableSalesList: disable
                            }, () => {
                                this.addTaxValidation();
                                this.getLocationSaleList(true);
                            });
                        }
                        else {
                            disable = true
                            this.setState({
                                saleLevelIrm: response.data.data[0]['saleitemreceiptmethod'],
                                formLoading: false,
                                disableSalesList: disable
                            }, () => {
                                this.addTaxValidation();
                                this.getLocationSaleList(false);
                            });
                        }

                        this.setItemReceiptMethod(JSON.stringify(this.state.settings.itemreceiptmethod.value));              
                    }
                }
             
             
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.formLoading = false;
                this.setState({
                    ...this.state,
                    formLoading: false,
                    itemStatus: { show: true, type: 'danger', message: error.response?.data['message'] }
                });
            });

    }

    /* Get Location & category list */
    getLocationCategoryList = async () => {
        await axios.all([
            await axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
            await axios.get(getSellerUrl(roomsMappingList), getSellerHeaders()),
            
        ])
            .then(response => {
                this.locations = ArrayValueReorder(response[0].data.data, 'title');
                let _catList = response[1].data.data.data
                // category.map((item) => {
                //     return item.sort()
                // })
                let data = []
                _catList.forEach(item => {
                    let _data = {
                        "category": item.category,
                        "subcategory": item.selection
                    }
                    data.push(_data)
                });
                // _catList.map((item) => {
                //     let _data = {
                //      "category": item.category,
                //      "subcategory": item.selection
                //    }
                //    data.push(_data)
                //  })
                this.category = data
                if (this.edit) {
                    this.setState({
                        formLoading: false,
                        detail: {
                            ...this.state.detail,
                            locationid: {
                                ...this.state.detail.locationid,
                                value: this.locations.length === 1 ? this.locations[0]['id'] : this.state.detail.locationid.value,
                                valid: this.locations.length === 1 ? true : this.state.detail.locationid.valid
                            }
                        }
                    }, () => {
                        this.addTaxValidation();
                        if (this.locations.length === 1)
                            this.getLocationSaleList(true, true);

                       

                    });
                }
                else if (!this.edit) {
                    this.getItemData();
                    this.getItemImages(true);
                   

                }
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.formLoading = false;
                this.setState({
                    ...this.state,
                    formLoading: false,
                    itemStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                });
            });
    }

    /* Get item for updation */
    getItemData = () => {
        let formData = {};
        if (!this.edit) {
           
            /* get user details */
            axios.get(getSellerUrl(`${itemdetail}/${this.itemId}`), getSellerHeaders())
                .then(response => {
                    if (response.status === 200) {
                        formData = response.data.data[0];
                        this.selectedSaleId = formData.saleid;

                        const condition = this.validateAndSetCondition(formData.condition);
                        /* set data to state*/
                        this.setState({
                            ...this.state,
                            detail: {
                                locationid: { ...this.state.detail.locationid, value: formData.locationid, valid: formData.locationid ? true : false },
                                saleid: { ...this.state.detail.saleid, value: formData.saleid, valid: formData.saleid ? true : false },
                                category: { ...this.state.detail.category, value: formData.categoryGroup + '#*#' + formData.category, valid: formData.category ? true : false },
                                area: { ...this.state.detail.area, value: formData.area, valid: true },
                                title: { ...this.state.detail.title, value: formData.title, valid: formData.title ? true : false },
                                SKU: { ...this.state.detail.SKU, value: formData.SKU, valid: formData.SKU ? true : false },
                                condition: { ...this.state.detail.condition, value: condition, valid: condition ? true : false },
                                description: { ...this.state.detail.description, value: formData.description ? formData.description : '', valid: formData.description ? true : false },
                                itemstatus: { ...this.state.detail.itemstatus, value: formData.itemstatus.charAt(0).toUpperCase() + formData.itemstatus.slice(1), valid: formData.itemstatus ? true : false },
                                categoryGroup: { ...this.state.detail.categoryGroup, value: formData.categoryGroup },
                            },
                            settings: {
                                isshippable: { ...this.state.settings.isshippable, value: formData.isshippable === 1 ? true : false },
                                isfeatured: { ...this.state.settings.isfeatured, value: formData.isfeatured === 1 ? true : false },
                                istaxable: { ...this.state.settings.istaxable, value: formData.istaxable === 1 ? false : true },
                                startingprice: { ...this.state.settings.startingprice, value: formData.startingprice, valid: true, validators: Number(formData.itemtypeid) !== 1 ? [Validators.required(), Validators.maxDigit(10)] : [Validators.maxDigit(10)] },
                                reserveprice: { ...this.state.settings.reserveprice, value: formData.itemtypeid === 1 ? '' : formData.reserveprice ? formData.reserveprice.toFixed(2) : '', valid: true },
                                buynowprice: { ...this.state.settings.buynowprice, value: formData.buynowprice ? formData.buynowprice.toFixed(2) : '', valid: Number(formData.itemtypeid) === 1 && !formData.buynowprice ? false : true, validators: Number(formData.itemtypeid) === 1 ? [Validators.required(), Validators.maxDigit(10)] : [Validators.maxDigit(10)] },
                                buyerspremium: { ...this.state.settings.buyerspremium, value: formData.buyerspremium != null ?  formData.buyerspremium.toFixed(3) : '' , valid: true },
                                // width: { ...this.state.settings.width, value: formData.width ? formData.width : '', validators: formData.isshippable ? [Validators.required(), Validators.maxDigit(4)] : [Validators.maxDigit(4)] },
                                // height: { ...this.state.settings.height, value: formData.height ? formData.height : '', validators: formData.isshippable ? [Validators.required(), Validators.maxDigit(4)] : [Validators.maxDigit(4)] },
                                // length: { ...this.state.settings.length, value: formData.length ? formData.length : '', validators: formData.isshippable ? [Validators.required(), Validators.maxDigit(4)] : [Validators.maxDigit(4)] },
                                // weight: { ...this.state.settings.weight, value: formData.weight ? formData.weight : '', validators: formData.isshippable ? [Validators.required(), Validators.maxDigit(4)] : [Validators.maxDigit(4)] },
                                width: { ...this.state.settings.width, value: formData.width ? formData.width : '' },
                                height: { ...this.state.settings.height, value: formData.height ? formData.height : '' },
                                length: { ...this.state.settings.length, value: formData.length ? formData.length : '' },
                                weight: { ...this.state.settings.weight, value: formData.weight ? formData.weight : '' },
                                shippingfee: { ...this.state.settings.shippingfee, value: formData.shippingfee ? formData.shippingfee.toFixed(2) : formData.shippingfee === 0 ? 0 : '', validators: [Validators.maxDigit(10)] },
                                handlingfee: { ...this.state.settings.handlingfee, value: formData.handlingfee ? formData.handlingfee.toFixed(2) : formData.handlingfee === 0 ? 0 : '', validators: [Validators.maxDigit(10)] },
                                itemtypeid: { ...this.state.settings.itemtypeid, value: formData.itemtypeid, valid: formData.itemtypeid ? true : false },
                                goal: { ...this.state.settings.goal, value: formData.goal ? formData.goal.toFixed(2) : '', valid: true },
                                valuation: { ...this.state.settings.valuation, value: formData.valuation ? formData.valuation.toFixed(2) : '', valid: true },
                                quantity: { ...this.state.settings.quantity, value: formData.quantity, valid: true },
                                tax: { ...this.state.settings.tax, value: formData.tax != null ? formData.tax.toFixed(3) : '', validators: formData.istaxable ? [Validators.required(), Validators.maxDigit(3)] : [Validators.maxDigit(3)], valid: formData.istaxable ? formData.tax ? true : false : true },
                                tag: { ...this.state.settings.tag, value: formData.tag ? formData.tag.split(',') : [], valid: true },
                                itemreceiptmethod: {...this.state.settings.itemreceiptmethod, value: formData.itemreceiptmethod ? JSON.parse(formData.itemreceiptmethod) : {"pickup": false, "delivery": false, "shipping": false}},
                                fragilityscore: { ...this.state.settings.fragilityscore, value: formData.fragilityscore },
                                material: { ...this.state.settings.material, value: formData.material  },
                                specialtyshippeditems: { ...this.state.settings.specialtyshippeditems, value: formData.specialtyshippeditems === 1 ? true : false },
                            },
                            itemLevelIrm: formData.itemreceiptmethod ? formData.itemreceiptmethod : {"pickup": false, "delivery": false, "shipping": false},
                            closingorder: formData?.closingorder,
                            formLoading: false,
                        }, () => {
                            // this.getArea(formData.area)
                            this.getSaleLocation();
                            this.addTaxValidation();
                        })
                    }
                    const categoryData = this.state.detail.category.value.split('#*#');
                    this.setSaleType(categoryData[1]);
                })
                .catch(error => {
                    // toast.error(error.response.data['message']);
                    if(error.response?.status == 401 || error.response?.status == 404) {
                        this.setState({
                            errorpageredirect: true,
                            errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                        })
                    }
                    this.formLoading = false;
                    this.setState({
                        formLoading: false,
                        // itemStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                    });
                });
        }
    }

    validateAndSetCondition = (condition) => {
        let data = this.state.conditionData.filter(data => { return data.condition === condition });
        if ( data.length > 0 ) {
            return data[0]['condition'];
        }

        let index = this.state.conditionData.findIndex(data => { return data.condition === 'FAIR'; });
        return index > -1 ? this.state.conditionData[index]['condition'] : this.state.conditionData[0]['condition'];
    }

    getBool(val) {
        try{
            if(val)
            return !!JSON.parse(String(val).toLowerCase());
            else
            return false
        }catch(e){
            return false
        }
    }

    /* get item images when updation */
    getItemImages = async (loader = true) => {
        let payload = {
            filter: [{ field: 'itemid', value: Number(this.state.itemid), op: '=', join: 'AND' }],
            sort: [{ field: 'displayorder', direction: "asc" }]
        }
        
        this.setState({ formLoading: loader });
        await axios.post(getSellerUrl(itemimagelist), JSON.stringify(payload), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.dokaConvertedImage = [];
                    if (response.data['data'].length) {
                        let imageArr = [];
                        // let displayIndex;
                        // response.data['data'].forEach((image, index) => {
                        //     if (image['isdisplayimage'])
                        //         displayIndex = index;

                        // });
                        // if (displayIndex !== 0) {
                        //     let temp = response.data['data'][displayIndex];
                        //     response.data['data'][displayIndex] = response.data['data'][0];
                        //     response.data['data'][0] = temp;
                        // }
                        response.data['data'].forEach(image => {
                            let imageTemp = {};
                            imageTemp['src'] = image['url'];
                            imageTemp['type'] = image['type'];
                            imageTemp['value'] = '';
                            imageTemp['id'] = image['id'];
                            imageTemp['isedit'] = true;
                            imageTemp['isDokaConverted'] = false;
                            imageTemp['name'] = image['name'];
                            imageTemp['displayorder'] = image['displayorder'];
                            imageTemp['currentBid'] = this.state.currentBid;
                            imageTemp['isdisplayimage'] = Object.keys(image).includes('isdisplayimage') ? image['isdisplayimage'] : 0
                            if (imageTemp['isdisplayimage'])
                                this.mediaDisplayImageId = image['id'];

                            imageArr.push(imageTemp);
                        });
                        this.mediaImageValue = imageArr;
                        this.setState({
                            ...this.state,
                            media: {
                                ...this.state.media,
                                image: {
                                    ...this.state.media.image,
                                    value: imageArr,
                                    imgValue: imageArr,
                                    tempValue: imageArr,
                                    imgCount: response.data['data'].length
                                },
                                enableSave: false
                            },
                            formLoading: false
                        });
                    }
                    else {
                        this.setState({
                            formLoading: false,
                            media: {
                                ...this.state.media,
                                image: {
                                    ...this.state.media.image,
                                    imgCount: 0
                                },
                            },
                        })
                    }
                }
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    ...this.state,
                    formLoading: false,
                    itemStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                });
            });
    }

    /* get sale list for location */
    getLocationSaleList = (isClosed = true, inputChange = true) => {
        let saleValue = !this.isCallFromSale && this.edit ? this.state.detail.saleid.value : null;
        let filter = [
            { op: "LIKE", join: "AND", value: this.state.detail.locationid.value, field: "locationid" },
            { field: 'isDeleted', value: 0, op: '=', join: 'AND' }

        ];
        if (isClosed) {
            filter.push({ field: "status", value: "Closed", op: "!=", join: "AND" });
        }
        if (!inputChange) {
            axios.post(getSellerUrl(salelist), JSON.stringify({ filter: filter, field: ['id', 'title', 'tax', 'buyerspremium'] }), getSellerHeaders())
                .then(response => {
                    if (response.status === 200) {
                        this.sales = response.data.data;
                        const temp = ArrayValueReorder(response.data.data, 'title');
                        if (temp.length === 1)
                            saleValue = temp[0]['id'];
                        this.setState({
                            ...this.state,
                            sales: temp,
                            formLoading: false,
                            detail: {
                                ...this.state.detail,
                                saleid: {
                                    ...this.state.detail.saleid,
                                    value: saleValue,
                                    valid: saleValue ? true : false
                                }
                            }
                        }, () => {
                            if ((temp.length === 1 || this.state.detail.saleid.value) && this.edit) {
                                this.generateSKU();
                                this.setBuyerTax(saleValue);
                            }
                        });
                    }
                })
                .catch(error => {
                    let saleError = '';
                    if (error.response.status === 404) {
                        this.sales = [];
                        saleError = 'sale not available'

                    }
                    // else {
                    //     toast.error(error.response.data['message']);
                    // }
                    this.setState({
                        ...this.state,
                        formLoading: false,
                        detail: {
                            ...this.state.detail,
                            saleid: {
                                ...this.state.detail.saleid,
                                value: saleValue,
                                error: saleError
                            }
                        },
                        itemStatus: { show: saleError ? false : true, type: saleError ? '' : 'danger', message: saleError ? '' : error?.response?.data['message'] }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                itemStatus: { show: saleError ? false : true, type: saleError ? '' : 'danger', message: saleError ? '' : error?.response?.data['message'] }
                            })
                        }, 3000);
                    });
                });
        } else {
            this.selectedSale = [];
            this.setState({
                ...this.state,
                formLoading: false,
                sales: [],
                detail: {
                    ...this.state.detail,
                    saleid: {
                        ...this.state.detail.saleid,
                        value: saleValue,
                        valid: saleValue ? true : false
                    }
                }
            });
        }
    }

    /* Generate sku based on location and sale */
    generateSKU = (saleId) => {
        const saleid = saleId ? saleId : this.state.detail.saleid.value;
        axios.get(getSellerUrl(`${skugenerate}/${saleid}`), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        detail: {
                            ...this.state.detail,
                            SKU: {
                                ...this.state.detail.SKU,
                                value: response.data.data[0]['SKU'],
                                valid: true,
                                error: ''
                            }
                        }
                    }, () => this.checkFormValidity());
                }
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    ...this.state,
                    formLoading: false,
                    itemStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                });
            });
    }

    /* setting step when save clicked */
    setStep = (stepNumber) => {
        if (stepNumber === this.state.currentPage) {
            return
        }
        document.getElementById("scroller").scroll(0, 0)
        if (stepNumber === 3 && this.edit)
            this.submitForm();
        else {
            this.setState({
                ...this.state,
                currentPage: stepNumber
            }, () => {
                if (stepNumber === 2 && !this.edit)
                    this.checkFormValidity();
            });
        }
    }

    /* get category value */
    getCategoryGroup(groupIndex) {
        let categoryGroup = this.category[groupIndex].category;
        // let categoryGroup = '';
        // this.category.forEach(categoryItem => {
        //     categoryItem.subcategory.forEach(item => {
        //         let subcate = item.subcategory
        //         if (subcate === subcategory) {
        //             categoryGroup = categoryItem.category
        //         }
        //     });
        // });
        setTimeout(() => {
            this.setState({
                ...this.state,
                detail: {
                    ...this.state.detail,
                    categoryGroup: {
                        ...this.state.detail.categoryGroup,
                        value: categoryGroup ? categoryGroup : ''
                    }
                }
            })
        }, 100);
    }

    /* get area value */
    getArea(eventValue) {
        let mappedArea = '';

        this.category.forEach(categoryItem => {
            categoryItem.subcategory.forEach(item => {
                let subcate = item.subcategory
                if (subcate === eventValue[1]  && categoryItem.category === eventValue[0]) {
                    mappedArea = item.area
                }
            });
        });
        setTimeout(() => {
            this.setState({
                ...this.state,
                detail: {
                    ...this.state.detail,
                    area: {
                        ...this.state.detail.area,
                        value: mappedArea ? mappedArea : '',
                    }
                }
            })
        }, 100);
    }

    /* set sale type */
    setSaleType(catergoryValue) {
        if(CATERGORY.filter(t => t == catergoryValue).length > 0){
            setTimeout(() => {
                this.setState({
                    settings: {
                        ...this.state.settings.startingprice.value = '1',
                        ...this.state.settings,
                        itemtypeid: {
                            ...this.state.settings.itemtypeid,
                            value: '2',
                            valid: true,
                            error: ''
                        },
                        buynowprice: {...this.state.settings.buynowprice, value: '0.00', error: '', valid: true },
                    },
                    itemStatus: {
                        message: Number(this.state.settings.itemtypeid.value) === 3 && this.state.itemTypeError  ? "Onsite auction items are limited to Pickup Only. Please adjust your IRM settings to include Pickup." : "",
                    },
                    showItemType: false
                },()=>{

                    this.setItemReceiptMethod(this.state.itemLevelIrm ? this.state.itemLevelIrm :this.state.saleLevelIrm, true)
                    this.disableInvalidIrm(this.state.saleLevelIrm)
                })
            }, 1000);
        } else {
            setTimeout(() => {  
                this.setState({
                 itemTypeError: Number(this.state.settings.itemtypeid.value) === 3 && this.state.itemTypeError ? true : false,   
                 irmvalid: false,
                    itemStatus: {
                        ...this.state.itemStatus,
                        show: Number(this.state.settings.itemtypeid.value) === 3   ? true :false,
                        message: Number(this.state.settings.itemtypeid.value) === 3 && this.state.itemTypeError  ? "Onsite auction items are limited to Pickup Only. Please adjust your IRM settings to include Pickup." : "",
                    },
                    settings: {
                        ...this.state.settings,
                        itemtypeid: {
                            ...this.state.settings.itemtypeid,
                            value: this.state.settings.itemtypeid.value ? this.state.settings.itemtypeid.value : '2',
                            valid: true,
                            error: ''
                        }
                    },
                    showItemType: true
                })
             
            }, 1000);  
        }
    }
    
    /* called when input changed */
    inputChange = (event) => {
        const newvalues = ['shippingfee', 'handlingfee'];
        let eventValue = typeof event.target.value == "string" ? event.target.value.replace(/^\s+/, '') : event.target.value;
        let inputError = '';
        if (event.target.name === 'category') {
            const groupIndex = event.target.selectedOptions[0].id.split('#*#');
            const eventValueSplit = eventValue.split('#*#');
            this.setSaleType(eventValueSplit[1]);
            this.getArea(eventValueSplit)
            this.getCategoryGroup(groupIndex[0]);
        }
        if(event.target.name === "SKU"){
            eventValue = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
        }
        if(event.target.name === "quantity"){
            let value = event.target.value.replace(/[^0-9 ]/g, ''); 
            eventValue = value;
         }
        if (new Date(moment(this.state.endtime)) < new Date() && event.target.name === 'itemstatus') {
            this.setState({
                showItemStatusErrorModel: true,
            });
            return;
        }

        if (event.target.name === 'isshippable' && this.state.settings.isshippable.value === true) {
            setTimeout(() => {
                this.setState({
                    ...this.state,
                    settings: {
                        ...this.state.settings,
                        shippingfee: {
                            ...this.state.settings.handlingfee,
                            value: '',
                        },
                        handlingfee: {
                            ...this.state.settings.handlingfee,
                            value: '',
                        }
                    }
                });
            }, 100);
            
        }

        if (event.target.name === 'isshippable' || event.target.name === 'isfeatured' || event.target.name === 'istaxable' || event.target.name == 'specialtyshippeditems') {
            eventValue = !this.state.settings[event.target.name].value;
        }
        if (decimalTypes.includes(event.target.name)) {
            let threeDecimal = ['tax', 'buyerspremium'];
            if (threeDecimal.includes(event.target.name)) {
                if (eventValue) {
                    // eventValue = eventValue
                    //     .replace(/[^\d.]/g, '')
                    //     .replace(new RegExp("(^[\\d]{" + 3 + "})[\\d]", "g"), '$1')
                    //     .replace(/(\..*)\./g, '$1')
                    //     .replace(new RegExp("(\\.[\\d]{" + 3 + "}).", "g"), '$1');;
                    if (!eventValue.match(/^\d{1,}(\.\d{0,3})?$/)) {
                        if (isNaN(eventValue))
                            eventValue = '';
                        else
                            eventValue = eventValue
                                .replace(/[^\d.]/g, '')
                                .replace(new RegExp("(^[\\d]{" + 3 + "})[\\d]", "g"), '$1')
                                .replace(/(\..*)\./g, '$1')
                                .replace(new RegExp("(\\.[\\d]{" + 3 + "}).", "g"), '$1');
                    }
                    // else if (parseFloat(eventValue) === 0 && event.target.name === 'buyerspremium') {
                    //     eventValue = '';
                    // }
                }

                else {
                    eventValue = '';
                }
            }
            else if (!threeDecimal.includes(event.target.name)) {
                if (eventValue) {
                    if (!eventValue.match(/^\d{1,}(\.\d{0,2})?$/)) {
                        if (isNaN(eventValue))
                            eventValue = '';
                        else
                            eventValue = eventValue
                                .replace(/[^\d.]/g, '')
                                .replace(new RegExp("(^[\\d]{" + 10 + "})[\\d]", "g"), '$1')
                                .replace(/(\..*)\./g, '$1')
                                .replace(new RegExp("(\\.[\\d]{" + 2 + "}).", "g"), '$1');
                    }
                    else if (parseFloat(eventValue) === 0) {
                        if ((this.state.settings.isshippable.value && newvalues.includes(event.target.name)))
                            eventValue = 0;
                        else
                            eventValue = '';
                    }
                }
                else {
                    eventValue = '';
                }

            }
        }
        if (priceValidation.includes(event.target.name)) {
            this.checkPriceValidation(event.target.name, eventValue);
        }

        /*validation */
        if (Object.keys(this.state[step[this.state.currentPage]][event.target.name]).includes('validators')) {
            for (let validator of this.state[step[this.state.currentPage]][event.target.name].validators) {
                inputError = validator(eventValue);
                if (inputError) break;
            }
        }
        if (event.target.name === 'buyerspremium' || event.target.name === 'tax') {
            if ((event.target.value.includes('.') && event.target.value.split('.')[1].length > 3)) {
                return;
            }
            if (this.timeoutInterval[event.target.name]) {
                clearTimeout(this.timeoutInterval[event.target.name]);
            }
            this.timeoutInterval[event.target.name]  = setTimeout(() => {
                if (event.target.value) {
                     let formattedValue = parseFloat(event.target.value).toFixed(3)
                    this.setState({
                        ...this.state,
                        [step[this.state.currentPage]]: {
                            ...this.state[step[this.state.currentPage]],
                            [event.target.name]: {
                                ...this.state[step[this.state.currentPage]][event.target.name],
                                value: formattedValue,
                                error: inputError,
                                valid: !Boolean(inputError),
                            }
                        }

                    })
                }
            }, 1000);

        }
        if (event.target.name === 'reserveprice' || event.target.name === 'buynowprice' || event.target.name === 'goal' || event.target.name === 'valuation' || event.target.name === "shippingfee" || event.target.name === "handlingfee") {
            if (event.target.value.includes('.') && event.target.value.split('.')[1].length > 2) {
                return;
            }
            if (this.timeoutInterval[event.target.name]) {
                clearTimeout(this.timeoutInterval[event.target.name]);
            }

            this.timeoutInterval[event.target.name] = setTimeout(() => {
                if (event.target.value) {

                    let formattedValue = parseFloat(event.target.value).toFixed(2)

                    this.setState({
                        ...this.state,
                        [step[this.state.currentPage]]: {
                            ...this.state[step[this.state.currentPage]],
                            [event.target.name]: {
                                ...this.state[step[this.state.currentPage]][event.target.name],
                                value: formattedValue,
                                error: inputError,
                                valid: !Boolean(inputError),
                            }
                        }
                    })
                }
            }, 1000);

        }
        // if (event.target.name === 'tax') {
        //     if (!this.state.settings.istaxable.value) {
        //         if (parseFloat(eventValue) === 0)
        //             inputError = 'Should be greater than zero';
        //     }

        // }
        this.setState({
            ...this.state,
            isEdit: true,
            [step[this.state.currentPage]]: {
                ...this.state[step[this.state.currentPage]],
                [event.target.name]: {
                    ...this.state[step[this.state.currentPage]][event.target.name],
                    value: eventValue,
                    error: inputError,
                    valid: !Boolean(inputError),

                }
            }
        }, () => {

            if (event.target.name === 'locationid' && !inputError.length) {
                this.getLocationSaleList(true, true);
            }
            if (event.target.name === 'saleid' && !inputError.length) {
                if (event.target.value === "Select Sale") {
                    this.setState({
                        detail: {
                            ...this.state.detail,
                            locationid: {
                                ...this.state.detail.locationid,
                                //value: response.data.data[0]['locationid'],
                                valid: true
                            },
                            saleid: {
                                ...this.state.detail.saleid,
                                value: "",
                                valid: false
                            }
                        }
                    });
                }
                else {
                    this.setState({
                        detail: {
                            ...this.state.detail,
                            saleid: {
                                ...this.state.detail.saleid,
                                value: event.target.value,
                                valid: false
                            }
                        }
                    }, () => {
                        this.generateSKU();
                        this.setBuyerTax(eventValue);
                        this.getSaleDetails()
                    });
                }
            }
            if (event.target.name === 'istaxable') {
                this.addTaxValidation();
            }

            if (event.target.name === 'itemtypeid') {
                this.addBuyNowReservePriceValidator(eventValue);
                if(event.target.value === "3"){
                    this.itemTypeValidation(true) 
                }
                else{
                  
                        setTimeout(() => {
                                this.setItemReceiptMethod(this.state.itemLevelIrm ? this.state.itemLevelIrm : this.state.saleLevelIrm, true)
                                this.disableInvalidIrm(this.state.saleLevelIrm)
                            
                            this.setState({
                                itemTypeError: false,
                                   itemStatus: {
                                       ...this.state.itemStatus,
                                       show:  false,
                                        message:''
                                   }
                            })
                        }, 100);
                   
                }
            }
            if (event.target.name === 'itemstatus') {
                if (!this.edit) {
                    let disable = this.state.disableSalesList;
                    if (event.target.value.toLowerCase() === "pending") {
                        document.getElementById("DisableSale").style.pointerEvents = "auto"
                        document.getElementById("DisableSale").style.opacity = 1
                        disable = false;
                        this.setState({
                            disableSalesList: disable
                        }, () => {
                            this.addTaxValidation();
                            // this.getLocationSaleList(true);
                        });
                    }
                    else {
                        document.getElementById("DisableSale").style.pointerEvents = "none"
                        document.getElementById("DisableSale").style.opacity = 0.4
                        disable = true
                        this.setState({
                            detail: {
                                ...this.state.detail,
                                saleid: {
                                    ...this.state.detail.saleid,
                                    value: this.selectedSaleId,
                                    valid: true
                                }
                            },
                            disableSalesList: disable
                        }, () => {
                            this.addTaxValidation();
                            //this.getLocationSaleList(false);
                        });
                    }
                }
            }

            /* check form validity */
            if (inputError || !this.state[step[this.state.currentPage]][event.target.name].valid) {
                this.setState({
                    ...this.state,
                    [step[this.state.currentPage]]: {
                        ...this.state[step[this.state.currentPage]],
                        formValid: false
                    }
                });
            }
            else {
                this.checkFormValidity();
            }
        });
    }
    checkFormValidity = () => {

        let valid = true;
        let formError = this.state.itemStatus.message;
        var invalidlist = Object.values(this.state[step[this.state.currentPage]]).filter(item => (typeof item === "object" && item !== null && item.valid === false))
        if (invalidlist.length > 0) {
            valid = false
        }
        if (valid)
            formError = this.state.itemStatus.message === 'Cannot save: please add the required fields' ? '' : this.state.itemStatus.message;
        setTimeout(() => {
            this.setState({
                ...this.state,
                [step[this.state.currentPage]]: {
                    ...this.state[step[this.state.currentPage]],
                    formValid: valid,
                },
                itemStatus: {
                    ...this.state.itemStatus,
                    message: formError
                }
            });
        });
    }
    /* set buyerpremium and tax when sale selected */
    setBuyerTax = (saleValue) => {
        var saleItem = this.state.tempSale.filter((item) => item['id'] === Number(saleValue));
        if (saleItem.length > 0) {
            this.setState({
                settings: {
                    ...this.state.settings,
                    buyerspremium: {
                        ...this.state.settings.buyerspremium,
                        value: parseFloat(saleItem[0].buyerspremium).toFixed(3),
                        valid: true,
                        error: ''
                    },
                    tax: {
                        ...this.state.settings.tax,
                        value: parseFloat(saleItem[0].tax).toFixed(3),
                        valid: false,
                        error: ''
                    }
                }
            }, () => {
                // this.addTaxValidation();
            })
        }
        // let saleIndex = '';
        // this.state.sales.forEach((sale, index) => {
        //     if (sale['id'] === Number(saleValue)){
        //         saleIndex = index;
        //     }    
        // });
        // setTimeout(() => {
        //     this.setState({
        //         settings: {
        //             ...this.state.settings,
        //             buyerspremium: { ...this.state.settings.buyerspremium, value: saleIndex || saleIndex === 0 ? this.state.sales[saleIndex].buyerspremium ? this.state.sales[saleIndex].buyerspremium : '' : '', valid: true, error: '' },
        //             tax: { ...this.state.settings.tax, value: saleIndex || saleIndex === 0 ? this.state.sales[saleIndex].tax ? this.state.sales[saleIndex].tax : '' : '', valid: false, error: '' }
        //         }
        //     }, () => {
        //         this.addTaxValidation();
        //     });
        // });
    }

    checkPriceValidation = (name, value) => {
        if (this.state.settings.itemtypeid !== 1) {
            if (name === 'startingprice') {
                priceValidation.forEach(control => {
                    if (parseFloat(value) >= parseFloat(this.state.settings[control].value) && control !== name) {
                        setTimeout(() => {
                            this.setState({ settings: { ...this.state.settings, [control]: { ...this.state.settings[control], error: 'Should be greater than starting price', valid: false } } })
                            this.checkFormValidity();
                        });
                    }
                    else {
                        if (parseFloat(value) < parseFloat(this.state.settings[control].value) && control !== name) {
                            setTimeout(() => {
                                this.setState({ settings: { ...this.state.settings, [control]: { ...this.state.settings[control], error: '', valid: true } } })
                                this.checkFormValidity();
                            });
                        }
                    }
                });
            }
            else {
                if (parseFloat(value) <= parseFloat(this.state.settings.startingprice.value)) {
                    setTimeout(() => {
                        this.setState({ settings: { ...this.state.settings, [name]: { ...this.state.settings[name], error: 'Should be greater than starting price', valid: false } } })
                        this.checkFormValidity();
                    });
                }
            }
        }
        else {
            priceValidation.forEach(control => {
                if (control === 'buynowprice') {
                    setTimeout(() => {
                        this.setState({ settings: { ...this.state.settings, [control]: { ...this.state.settings[control], error: ' ', valid: this.state.settings[control].value ? true : false } } })
                        this.checkFormValidity();
                    });
                }
                else {
                    setTimeout(() => {
                        this.setState({ settings: { ...this.state.settings, [control]: { ...this.state.settings[control], error: ' ', valid: true } } })
                        this.checkFormValidity();
                    });

                }
            });
        }
    }

    /* set validator for buynowprice based on item type */
    addBuyNowReservePriceValidator = (eventValue) => {
        priceValidation.forEach(control => {
            let valid = this.state.settings[control].valid;
            let error = this.state.settings[control].error;
            let value = this.state.settings[control].value;
            let validator = this.state.settings[control].validators;
            if (Number(eventValue) !== 1) {
                if (control !== 'startingprice') {
                    if (control === 'buynowprice')
                        validator = [Validators.maxDigit(10)];
                    error = Number(this.state.settings[control].value) ? Number(this.state.settings[control].value) > 1 ? this.state.settings[control].error.includes('Maximum') ? this.state.settings[control].error : '' : 'Should be greater than starting price' : '';
                    valid = Number(this.state.settings[control].value) ? Number(this.state.settings[control].value) > 1 ? this.state.settings[control].error.includes('Maximum') ? false : true : false : true;
                }
                else {
                    value = 1;
                    validator = [Validators.required(), Validators.maxDigit(10)];
                }
            }
            else {
                if (control === 'buynowprice') {
                    validator = [Validators.required(), Validators.maxDigit(10)];
                    if (!value) {
                        if (!this.edit)
                            error = this.state.settings[control].error.includes('Maximum') ? this.state.settings[control].error : 'Please enter value';
                        valid = false;
                    }
                    else {
                        error = this.state.settings[control].error.includes('Maximum') ? this.state.settings[control].error : '';
                        valid = this.state.settings[control].error.includes('Maximum') ? false : true;
                    }
                }
                else if (control === 'startingprice') {
                    // Direct Buy: starting price is not required
                    value = '';
                    validator = [Validators.maxDigit(10)];
                    error = '';
                    valid = true;
                }
                else {
                    if (control === 'reserveprice')
                        value = '';
                    error = this.state.settings[control].error.includes('Maximum') ? this.state.settings[control].error : '';
                    valid = this.state.settings[control].error.includes('Maximum') ? false : true;
                }

            }
            setTimeout(() => {
                this.setState({
                    settings: {
                        ...this.state.settings,
                        [control]: {
                            ...this.state.settings[control],
                            value: value,
                            error: error,
                            valid: valid,
                            validators: validator
                        }
                    }
                }, () => {
                    this.checkFormValidity()
                    if(Number(this.state.settings.itemtypeid.value) === 3) {
                        this.setState({
                            settings: {
                                ...this.state.settings,
                                isshippable: {...this.state.settings.isshippable,value: false, valid: true },
                                reserveprice: {...this.state.settings.reserveprice, value: '', error: '', valid: true },
                                buynowprice: {...this.state.settings.buynowprice, value: '', error: '', valid: true },
                            }
                        });
                   }
                })
            });

        })
    }

    addTaxValidation = () => {
        if (!this.state.settings.istaxable.value) {
            this.setState({
                settings: {
                    ...this.state.settings,
                    tax: {
                        ...this.state.settings.tax,
                        error: this.state.settings.tax.error.includes('Maximum') ? this.state.settings.tax.error : '',
                        valid: this.state.settings.tax.error.includes('Maximum') ? false : true,
                        validators: [Validators.required(), Validators.maxDigit(3)]
                    }
                }
            }, () => {
                this.checkFormValidity();
            });
        }
        else {
            this.setState({
                settings: {
                    ...this.state.settings,
                    tax: {
                        ...this.state.settings.tax,
                        error: this.state.settings.tax.error.includes('Maximum') ? this.state.settings.tax.error : '',
                        valid: this.state.settings.tax.error.includes('Maximum') ? false : true,
                        validators: [Validators.maxDigit(3)]
                    }
                }
            }, () => {
                this.checkFormValidity();
            });

        }

    }

    /* This will handle multiple toast message displaying */
    handleToastMessgae = (error) => {
        const check = defaultToast.isActive(this.errorToasterId);
        if (check) {
            defaultToast.update(this.errorToasterId);
        } else {
            this.errorToasterId = defaultToast.error(error, this.TOAST_CONFIG);
        }

    }

    /* called when tag input field changed */
    tagValueUpdate = (event) => {
        let value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, ''); 
        event.target.value = value;
        this.setState({
            ...this.state,
            isEdit: true,
            tagValue: event.target.value
        }, () => {
            const without_current = this.state.settings.tag.value.join('').length + this.state.settings.tag.value.length;
            const get_length = this.state.settings.tag.value.join('').length + this.state.tagValue.length + this.state.settings.tag.value.length;
            if (without_current < 301) {
                get_length > 300 ? this.setTagError() : this.removeTagError();
            } else {
                this.state.tagValue.length > 0 ? this.setTagError() : this.removeTagError();
            }
        });
    }

    setTagError = () => {
        var settings = this.state.settings
        settings.tag.error = "Maximum characters 300";
        this.setState({
            ...this.state,
            disableButton: true,
            settings
        });
    }

    removeTagError = () => {
        var settings = this.state.settings
        settings.tag.error = "";
        this.setState({
            ...this.state,
            disableButton: false,
            settings
        });
    }

    /* Called when enter key press inside tag input */
    tagChange = (event) => {
        let arr = [];
        let inputError = '';
        if (event.key === 'Enter' && event.target.value && !this.state.settings.tag.error) {
            if (this.state.settings.tag.value.length)
                arr = this.state.settings.tag.value;
            const check = arr.findIndex(x => x.toLowerCase() === event.target.value.toLowerCase()) === -1;
            // for (let validator of this.state.settings.tag.validators)
            //     inputError = validator(arr.join());
            if (check) {
                arr.push(event.target.value);
                document.getElementById('tag').value = '';
            } else {
                this.handleToastMessgae(`Tag already exists`);
            }
            this.setState({
                ...this.state,
                isEdit: true,
                settings: {
                    ...this.state.settings,
                    tag: {
                        ...this.state.settings.tag,
                        value: arr,
                        valid: !Boolean(inputError),
                        error: inputError
                    }
                }
            }, () => {
                this.checkFormValidity();
            });

        }
    }

    /* called when tag removed */
    removeTag = (data) => {
        let arr = this.state.settings.tag.value;
        if (arr.length && arr.includes(data)) {
            let index = arr.indexOf(data);
            arr.splice(index, 1);
            this.setState({
                ...this.state,
                isEdit: true,
                settings: {
                    ...this.state.settings,
                    tag: {
                        ...this.state.settings.tag,
                        value: arr,
                        valid: true,
                        error: ''
                    }
                }
            }, () => {
                this.checkFormValidity();
            });

        }
    }

    /* called when submit button clicked */
    checkFieldValidations = (mediaSave = false) => {
        if (!this.state.itemTypeError) {
            const pages = Object.values(step); // ['detail','settings','media']
            let anyInvalid = false;
            let firstInvalidPage = null;
            const updatedPages = {};

            pages.forEach(page => {
                const controls = { ...this.state[page] };
                let pageValid = true;

                for (const key of Object.keys(controls)) {
                    const ctrl = controls[key];
                    if (key === 'itemreceiptmethod' && ctrl && ctrl.valid === false) {
                        pageValid = false;
                        break;
                    }
                    if (ctrl && typeof ctrl === 'object' && Object.prototype.hasOwnProperty.call(ctrl, 'validators')) {
                        let err = '';
                        for (const validator of ctrl.validators) {
                            err = validator(ctrl.value);
                            if (err) {
                                pageValid = false;
                                break;
                            }
                        }
                        controls[key] = { ...ctrl, error: err, valid: !Boolean(err) };
                    }
                }

                controls.formValid = pageValid;
                updatedPages[page] = controls;
                if (!pageValid && !firstInvalidPage) firstInvalidPage = page;
                if (!pageValid) anyInvalid = true;
            });

            this.setState({
                ...this.state,
                ...updatedPages,
                itemStatus: { show: anyInvalid, type: anyInvalid ? 'danger' : '', message: anyInvalid ? 'Cannot save: please add the required fields' : '' }
            }, () => {
                if (!anyInvalid) {
                    if (this.state[step[this.state.currentPage]].formValid) {
                        if (this.state.currentPage !== 1) {
                            if (this.edit) {
                                this.setState({ showConfirmModal: true });
                            }
                        }
                        // if this action is a media save, directly process media conversion/save
                        if (mediaSave) {
                            if (this.edit) {
                                this.convertToDokaImage();
                            } else {
                                this.submitForm(false);
                            }
                        } else {
                     if (!this.edit) {
                        this.submitForm(true);
                    }
                    else if (this.state.currentPage === 1 && this.edit) {
                        this.setState({ currentPage: this.state.currentPage + 1 });
                    }
                    }
                }
                }
        });
    }
    else if (this.state.currentPage === 1 && this.edit ) {
        this.setState({ currentPage: this.state.currentPage + 1 });
    }

    }

    /* called when save & proceed clicked and submit the data */
    submitForm = (isNavigateMedia) => {
        if(!this.state.itemTypeError){
        
        let data = {};
        this.setState({ loading: true });
        // if(this.state.formValid){
        let formKeys = Object.keys(this.state);
        formKeys.forEach(control => {
            if (control !== 'formValid' && control !== 'currentPage' && control !== 'media' && control !== 'itemid' && control !== 'tagValue' && control !== "searchInput" && control !== "showSearchBox" && control!=='webWorker' && control!=='mainThread' && control!== 'checkPointMessage') {
                Object.entries(this.state[control]).forEach(([key, value]) => data[key] = value['value']);
            }
        })
        delete data['formValid'];
        delete ['editModal'];
        delete ['viewModal']
        data['tag'] = data['tag'].join();
        if (this.edit) {
            if (data['saleid'] !== '')
                localStorage.setItem('previousSaleId', data['saleid']);
        }
        // data['category'] = this.category.filter(x => x['id'] === Number(data['category']))[0]['category'];
        data['category'] = data['category'].split('#*#')[1];
        data['istaxable'] = !data['istaxable'];
        // data['condition'] = null;
        // if (!data['isshippable']) {
        //     let arr = ['shippingfee', 'handlingfee'];
        //     arr.forEach(control => {
        //         if (data.hasOwnProperty(control))
        //             delete data[control];
        //     })
        // }
        // if (!data['goal'])
        //     delete data['goal'];
        // if (!data['valuation'])
        //     delete data['valuation'];
        decimalTypes.forEach(control => {
            if (data[control] === '')
                data[control] = null;
        })
        data['startingprice'] = data['startingprice'] ? parseFloat(data['startingprice']) : data['startingprice'];
        data['reserveprice'] = data['reserveprice'] ? parseFloat(data['reserveprice']) : data['reserveprice'];
        data['buynowprice'] = data['buynowprice'] ? parseFloat(data['buynowprice']) : data['buynowprice'];
        data['buyerspremium'] = data['buyerspremium'] ? parseFloat(data['buyerspremium']) : data['buyerspremium'];
        data['tax'] = data['tax'] ? parseFloat(data['tax']) : data['tax'];
        data['quantity'] =  this.state.settings.quantity?.value ? this.state.settings.quantity?.value : '';
        data['area'] = data['area'] ? data['area'] : null;
        data['material'] = data['material'] ? data['material'] : null;
        data['fragilityscore'] = data['fragilityscore'] ? parseInt(data['fragilityscore']) : null;
        data['condition'] = data['condition'] ? data['condition'] : null;
        data['closingorder'] = this.state.detail.itemstatus.value === 'Ready' ? this.state.closingorder : 999
        data['itemreceiptmethod'] = this.state.settings.itemreceiptmethod.value;
        data['isshippable'] = false;
        if (this.edit) {
            axios.post(getSellerUrl(itemadd), JSON.stringify({ data: data }), getSellerHeaders())
                .then(response => {
                    if (response.status === 200) {
                        if (this.state.currentPage === 1) {
                            this.setState({
                                currentPage: 2
                            });
                        }
                        // toast.success('Successful');
                        this.setState({
                            ...this.state,
                            loading: false,
                            showConfirmModal: false,
                            itemStatus: { show: true, type: 'success', message: 'Saved' }
                        });
                        if (isNavigateMedia) {
                            setTimeout(() => {
                                this.setState({
                                    ...this.state,
                                    currentPage: 3,
                                    itemid: response.data.data[0]['id'],
                                    loading: false,
                                    showConfirmModal: false,
                                    itemStatus: { show: false, type: '', message: '' }
                                });
                            }, 3000);
                        }
                        else
                            setTimeout(() => {
                                const state = this.props.location.state ? this.props.location.state : {};
                                delete state?.prevPath;
                                // this.props.history.push({ pathname: this.state.prevPath, state: state });
                                this.navigateToList();
                            }, 3000);
                    }
                })
                .catch(error => {
                    if(error.response?.status == 401 || error.response?.status == 404) {
                        this.setState({
                            errorpageredirect: true,
                            errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                        })
                    }
                    this.setState({
                        loading: false,
                        showConfirmModal: false,
                        itemStatus: { show: true, type: 'danger', message: Array.isArray(error.response.data['message']) && error.response.data['message'].length ? error.response.data['message'][0]['message'] : error.response.data['message'] }
                    });
                    // if (error.response.data['message'].length)
                    //     toast.error(error.response.data['message'][0]['message']);
                    // else
                    //     toast.error(error.response.data['message']);

                })
        }
        else {
            data['id'] = this.state.itemid;
            axios.put(getSellerUrl(itemupdate), JSON.stringify({ data: data }), getSellerHeaders())
                .then(response => {
                    if (response.status === 200) {
                        // toast.success('Successful');
                        this.setState({
                            ...this.state,
                            isitemEdit:true
                            // loading: false,
                            // itemStatus: { show: true, type: 'success', message: 'Saved' }
                        });
                        setTimeout(() => {
                            const state = this.props.location.state;
                            delete state?.prevPath;
                            this.convertToDokaImage();
                            // this.props.history.push({ pathname: this.state.prevPath, state: state });
                        }, 3000);
                    }
                })
                .catch(error => {
                    if(error.response.status == 401 || error.response.status == 404) {
                        this.setState({
                            loading: false,
                            errorpageredirect: true,
                            errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                        })
                    } else {
                        this.setState({
                            loading: false,
                            itemStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                        });
                    }
                    // toast.error(error.response.data['message']);
                })
        }
        } 
    }

    convertToDokaImage = async () => {        
        // video is display image restrict api by function return
        if (this.state.media.image.value.length && this.state.media.image.value[0]['type'] === 'video') {
            this.setState({
                loading: false,
                itemStatus: { show: true, type: 'danger', message: 'Video should not be display image' }
            });
            return;
        }

        let itemMedia = this.state.media.image.value;
        let showProcessMediaPopUp = false;
        if (itemMedia.length > 0) {
            itemMedia.forEach((img, index) => {
                img['isdisplayimage'] = index === 0 ? 1 : 0;
                img['displayorder'] = index + 1;
                
                if ((img['id'] && img['isDokaConverted']) || !img['id']) {
                    showProcessMediaPopUp = true;
                }
            })
        }

        if ( showProcessMediaPopUp ) {
            this.setState({
                loading: true,
                // itemStatus: { show: true, type: 'danger', message: 'Media processing is in progress, please wait' },
                openMediaDialogModal: true
            });
        }
        this.deleteImageApi();

        this.processAllItemAssets(itemMedia).then(responses => {
            this.errorFileList = [];
            if (responses) {
                let isErrored = false;
                responses.forEach((elem, index) => {
                    if (!elem) {
                        isErrored = true;
                        this.errorFileList.push(itemMedia[index].file.name ? itemMedia[index].file.name : itemMedia[index].file.dest.name);
                    }
                });
                
                if (isErrored) {
                    this.setState({
                        dialogModalMessage: true,
                        modalMessage: { show: true, type: "danger", message: 'The following files failed to upload' }
                    })
                } else {
                    this.setState({
                        openMediaDialogModal: false,
                        dialogModalMessage: false
                    }, () => {
                        this.navigateToList();
                    });
                }
            }
        }).catch(error => {
            this.setState({
                loading: false,
                itemStatus: { show: true, type: 'danger', message: 'Error while uploading image.' }
            });
        });
    };

    deleteImageApi = async () => {
        if (this.deleteImageId.length) {
            let deleteData = { 'imageids': this.deleteImageId, 'itemid': this.state.itemid };
            await axios.delete(getSellerUrl(itemimagedelete), { ...getSellerHeaders(), data: { 'data': deleteData } })
                .then(response => {
                    if (response.data.status === 'success') {}
                })
                .catch(error => {
                    this.setState({
                        loading: false,
                        itemStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                    });
                });

        }
    };

    processAllItemAssets = async (itemAssets) => {
        return Promise.all(itemAssets.map((media, index) => {
            return new Promise((resolve, reject) => {
                if ( media['type'] == 'image' ) {
    
                    // Updating the image
                    if ( media['isedit'] && media['id'] ) {
                        this.processUpdateImage(media).then(response => {
                            resolve(response);
                        }).catch(error => {
                            reject(error);
                        })
                    } else { // Creating the image
                        this.processAddImage(media).then(response => {
                            resolve(response);
                        }).catch((error) => {
                            reject(error);
                        });
                    }
                } else {
                    // Updating the video
                    if ( media['isedit'] && media['id'] ) {
                        this.processUpdateVideo(media).then(response => {
                            resolve(response);
                        }).catch(error => {
                            reject(error);
                        })
                    } else { // Creating the video
                        this.processAddVideo(media).then(response => {
                            resolve(response);
                        }).catch((error) => {
                            reject(error);
                        });
                    }
                } 
            });
        }));
    }

    processAddImage = async (media) => {
        try {
            let data = {
                itemid: this.state.itemid,
                name: typeof media?.file?.dest?.name === 'string' ? media.file.dest.name.split('.')[0] : media.type === "image" ? 'image' : 'video',
                type: media['type'],
                isdisplayimage: media['isdisplayimage'] ? 1 : 0,
                displayorder: media['displayorder'],
            };

            if ( media['isDokaConverted'] ) {
                data['image'] = media['value'];
            } else {
                data['image'] = await getBase64Content(media?.file?.dest)
            }

            let response = await axios.post(getSellerUrl(itemimageadd), JSON.stringify({ data: data }), getSellerHeaders());
            return response.data;
        } catch (error) {
            return null;
        }
    };

    processUpdateImage = async (media) => {
        try {
            let data = {
                id: media['id'],
                itemid: this.state.itemid,
                name: media['name'],
                type: media['type'],
                isdisplayimage: media['isdisplayimage'] ? 1 : 0,
                displayorder: media['displayorder']
            };

            if ( media['isDokaConverted'] ) {
                data['image'] = media['value'];
            }

            let response = await axios.put(getSellerUrl(itemimageupdate), JSON.stringify({ data: data }), getSellerHeaders());
            return response.data;
        } catch (error) {
            return null;
        }
    };

    processAddVideo = async (media) => {
        try {
            const fileName = typeof media?.file?.name === 'string' ? media.file.name : 'video';
            const fileSize = media.file.size;

            let offset = 0;
            let chunkCount = 0;
            const chunkSize = Math.ceil(1024 * 1024 * 1); // equals to 3mb
            const totalChunks = Math.ceil(fileSize / chunkSize, chunkSize);
            
            const data = {
                filename: fileName,
                size: fileSize,
                partCount: totalChunks,
            }
            let response = await axios.post(getSellerUrl(fileUpload), JSON.stringify({ data: data }), getSellerHeaders());
            if ( response.data.status === 'success' ) {
                const partKey = response.data.partkey;
                const fileUrl = this.createFileUrl(data, partKey);

                while (chunkCount < totalChunks) {
                    offset = chunkCount * chunkSize;
                    const chunkFile = media.file.slice(offset, offset + chunkSize);

                    const fragmentData = {
                        partkey: partKey,
                        partid: chunkCount + 1,
                        content: await getBase64Content(chunkFile),
                    };
                    response = await axios.post(getSellerUrl(fileUploadFragment), { data: fragmentData }, getSellerHeaders());

                    chunkCount++;
                }

                if ( chunkCount === totalChunks ) {
                    let videoAddData = {
                        itemid: this.state.itemid,
                        name: fileName,
                        image: fileUrl,
                        type: media.type,
                        isdisplayimage: 0,
                        displayorder: media.displayorder
                    };
                    response = await axios.post(getSellerUrl(itemimageadd), JSON.stringify({ data: videoAddData }), getSellerHeaders());
                }
            }

            return response;

        } catch (error) {
            return null;
        }
    };

    processUpdateVideo = async (media) => {
        try {
            let data = {
                id: media['id'],
                itemid: this.state.itemid,
                name: media['name'],
                type: media['type'],
                isdisplayimage: media['isdisplayimage'] ? 1 : 0,
                displayorder: media['displayorder']
            };

            let response = await axios.put(getSellerUrl(itemimageupdate), JSON.stringify({ data: data }), getSellerHeaders());
            return response.data;
        } catch (error) {
            return null;
        }
    };

    receiptCheckBox = (event) => {

        let eventValue = event.target.checked;
        this.setState({
            isEdit: true,
            settings: {
                ...this.state.settings,
                itemreceiptmethod: {
                    ...this.state.settings.itemreceiptmethod,
                    value: {
                        ...this.state.settings.itemreceiptmethod.value,
                        [event.target.name]: eventValue
                    }
                }
            }
        }, () => {
            let valuecheck = this.state.settings.itemreceiptmethod.value;
            const irmvalue= Object.keys(valuecheck).filter(key => valuecheck[key] === true);
            if(irmvalue[0] === 'pickup' && irmvalue.length === 1){
                setTimeout(() => {
                    this.setState({
                        ...this.state,
                        settings: {
                            ...this.state.settings,
                            shippingfee: {
                                ...this.state.settings.handlingfee,
                                value: '',
                            },
                            handlingfee: {
                                ...this.state.settings.handlingfee,
                                value: '',
                            }
                        }
                    });
                }, 100);
            }
          
            this.validateIRM();
        });
    }

    validateIRM = () => {
        let isIRMValid = false;
        const keys = Object.keys(this.state.settings.itemreceiptmethod.value);
        keys.forEach(key => {
            if (this.state.settings.itemreceiptmethod.value[key]) {
                isIRMValid = true;
            }
        });
        setTimeout(() => {
            this.setState({
                settings: {
                    ...this.state.settings,
                    itemreceiptmethod: {
                        ...this.state.settings.itemreceiptmethod,
                        valid: isIRMValid,
                        error: isIRMValid ? '' : (this.state.settings.itemtypeid.value == "3") && !isIRMValid ? ''  : 'Please select an item receipt method'
                    }
                }
            });
            
        }, 10);  
    }

    itemTypeValidation = () => {
        let valuecheck =  JSON.parse(this.state.saleLevelIrm === "" ? JSON.stringify(this.state.settings.itemreceiptmethod.value) : this.state.saleLevelIrm );
        const irmvalue= Object.keys(valuecheck).filter(key => valuecheck[key] === true);

        if(irmvalue.includes('pickup')){
            setTimeout(() => {

            this.setItemReceiptMethod(`{"pickup":true,"delivery":false,"shipping":false}`)
            this.disableInvalidIrm(`{"pickup":true,"delivery":false,"shipping":false}`)
           
                this.setState({
                    settings: {
                        ...this.state.settings,
                        shippingfee: {
                            ...this.state.settings.shippingfee,
                            value: '',
                        },
                        handlingfee: {
                            ...this.state.settings.handlingfee,
                            value: '',
                        },
                    },
                })
                
            }, 100);
      
        }
        else{
            setTimeout(() => {
                this.setItemReceiptMethod(`{"pickup":false,"delivery":false,"shipping":false}`)
                this.disableInvalidIrm(`{"pickup":false,"delivery":false,"shipping":false}`, 'onsite')
                this.setState({
                    ...this.state,
                    settings: {
                        ...this.state.settings,
                        shippingfee: {
                            ...this.state.settings.shippingfee,
                            value: '',
                        },
                        handlingfee: {
                            ...this.state.settings.handlingfee,
                            value: '',
                        },
                    },
                    
                    // irmvalid: true,
                    itemTypeError: true,
                    itemStatus: {
                        ...this.state.itemStatus,
                        show: true,
                        message: "Onsite auction items are limited to Pickup Only. Please adjust your IRM settings to include Pickup." ,
                        type: 'danger'
                    }
                });
                
            }, 100);
        }
    }
    disableInvalidIrm = (saleIrm,ammoitem) => {
        let invalidIrm = [];
        if (typeof saleIrm === 'string' && saleIrm) {
            let irm = JSON.parse(saleIrm);
            const keys = Object.keys(irm);
            keys.forEach(key => {
                if (!irm[key]) {
                    invalidIrm.push(key)
                }
            });
        }
        let valuecheck = this.state.settings.itemreceiptmethod.value;
        const irmvalue= Object.keys(valuecheck).filter(key => valuecheck[key] === true);
        if(irmvalue){
            invalidIrm = invalidIrm.filter(irmName => !irmvalue.includes(irmName));
        }

        this.setState({
            invalidIrm: invalidIrm.length === 3 && ammoitem !== 'onsite' ? [] : invalidIrm
        });
    };

    setItemReceiptMethod = (irm) => {
        // IRM handling
        let currentIRM = {"pickup": false, "delivery": false, "shipping": false};
        
        if (typeof irm === 'string' && irm) {
            currentIRM = JSON.parse(irm);
        }
        
        this.setState({
            ...this.state,
            settings: {
                ...this.state.settings,
                itemreceiptmethod: {...this.state.settings.itemreceiptmethod, value: currentIRM},
            },
        }, () => {
            this.validateIRM();
        });
    };

    // generate file url, this url will be file's server url
    createFileUrl = (fileDetail, key) => {
        // this is the standard url format used in backend(finally convert to base64)
        return btoa(
            "BIG" +
            fileDetail["filename"] +
            "$" +
            key +
            "$" +
            fileDetail["size"] +
            "$" +
            fileDetail["partCount"]
        );
    };

    /* called when uploaded image deleted */
    deleteImage = (image) => {
        if (image === 'all') {
            let enableSave = false;
            this.largeFiles = [];
            this.state.media.image.value.forEach((image, index) => {
                if (image['id']) {
                    this.deleteImageId.push(image['id']);
                    // if (!this.edit)
                        enableSave = true;
                }
            });

            this.setState({
                ...this.state,
                isEdit: true,
                itemStatus: { show: false, type: '', message: '' },
                media: {
                    ...this.state.media,
                    image: {
                        ...this.state.media.image,
                        value: [],
                        tempValue: [],
                        imgValue: []
                    },
                    temImg: null,
                    deleteAllImage: false,
                    enableSave: enableSave
                },
            })
        }
        else {
            let imageValue = this.state.media.image.value;
            let imageIndex = '';
            let enableSave = false;
            for (let index in imageValue) {
                if (imageValue[index]['src'] === image) {
                    imageIndex = index;
                    break;
                }
            }
            if (imageValue[imageIndex]['id']) {
                this.deleteImageId.push(imageValue[imageIndex]['id']);
                if (!this.edit && imageValue.length === 1)
                    enableSave = true;
                if (imageValue[imageIndex]['isdisplayimage']) {
                    if (imageValue.length !== Number(imageIndex) + 1 && imageValue[Number(imageIndex) + 1]['id']) {
                        this.displayImageId = this.state.media.image.value[Number(imageIndex) + 1]['id'];
                        let media = this.state.media
                        media.image.value[Number(imageIndex) + 1]['isdisplayimage'] = 1;
                        this.setState({ media })
                    }

                }
            }
            else {
                if (imageValue[imageIndex]['isdisplayimage']) {
                    if (imageValue[Number(imageIndex) + 1])
                        imageValue[Number(imageIndex) + 1]['isdisplayimage'] = 1;
                }
            }
            imageValue.splice(imageIndex, 1);

            imageValue.forEach((image, index) => {
                image['isdisplayimage'] = 0
                if (index == 0) {
                    image['isdisplayimage'] = 1
                }
            });


            this.setState({
                ...this.state,
                isEdit: true,
                media: {
                    ...this.state.media,
                    image: {
                        ...this.state.media.image,
                        value: imageValue,
                        tempValue: imageValue,
                    },
                    enableSave: enableSave
                }
            }, () => {
                if(this.state.media.image.value.length == 0) {
                    this.setState({
                        itemStatus: { show: false, type: "", message: ''}
                    });
                    this.largeFiles = [];
                }
            });
        }
    }

    /* called when image edited */
    editImage = (image) => {
        let imageValue = this.state.media.image.value;
        imageValue.forEach((imageSrc, index) => {
            if (imageSrc['src'] === image)
                this.editImageIndex = index;

        });
        this.setState({
            ...this.state,
            isEdit: true,
            media: {
                ...this.state.media,
                temImg: image,
                modal: true
            },
            enableSave: false
        })
    }

    /* uploading image */
    uploadImage = () => {
        document.getElementById('image').click();
        this.setState({isEdit:true})
    }
    formatBytes(bytes){
        var kb = 1024;
        var ndx = Math.floor( Math.log(bytes) / Math.log(kb) );
        var fileSizeTypes = ["bytes", "kb", "mb", "gb", "tb", "pb", "eb", "zb", "yb"];
      
        return {
          size: +(bytes / kb / kb).toFixed(2),
          type: fileSizeTypes[ndx]
        };
      }

      
    
         
    /*New image added */
    changeImage = async (event) => {
        this.setState({isEdit:true})
        event.preventDefault();
        let index = 0;
        let progressCount = 0;
        this.largeFiles =[];
        this.percentage = 0;
        var imageValue = this.state.media.image.value.length ? this.state.media.image.value : [];
         
        let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        if(this.largeFiles.length===0){
            this.setState({ 
                itemStatus: { show: false, type: '', message: '' }});
        }

        if (files.length == 0) {
            return;
        }
        
        if ( (this.state.media.image.value.length + files.length) > this.totalMediaAllowed ) {
            this.setState({ 
                itemStatus: { show: true, type: "danger", message: 'You cannot upload more than 40 files' }
            }, () => {
                setTimeout(() => {
                    this.setState({ 
                        itemStatus: { show: false, type: "", message: '' }
                    });
                }, 5000);
            });
            return;
        }
       
        if (!imageValue.length && files[0]['type'].includes('video/')) {
            // toast.error('Video should not be display image');
            this.setState({
                itemStatus: { show: true, type: 'danger', message: 'Video should not be display image' }
            });
        }
        else if (!imageValue.length && !files[0]['type'].includes('video/')) {
            this.setState({
                itemStatus: { show: false, type: '', message: '' }
            });
        }
       
        let fileCount = 0;
        let allFiles = [];
        let unsupportedFiles = false;
        for (let list of files) {
            if ( !(IMAGE_TYPES.includes(list.type) || VIDEO_TYPES.includes(list.type)) ) {
                unsupportedFiles = true;
                this.largeFiles.push(list.name);
                continue;
            }

            if (list.type) {
                allFiles.push(list);

                if (!list.type.includes('video/')) {
                    ++fileCount;
                }
            } else {
                const mimetype = await FileType.fromBlob(list);
                const changeFile = new File([list], list.name, {type: mimetype.mime});
                if ( !(IMAGE_TYPES.includes(changeFile.type) || VIDEO_TYPES.includes(changeFile.type)) ) {
                    unsupportedFiles = true;
                    this.largeFiles.push(changeFile.name);
                    continue;
                }
                allFiles.push(changeFile);

                if (!changeFile.type.includes('video/')) {
                    ++fileCount;
                }
            }
        }

        if ( unsupportedFiles ) {
            this.setState({
                itemStatus: { show: true, type: 'danger', message: 'The following files is not supported.' }
            });
        }

        if ( allFiles.length == 0 ) {
            return;
        }

        this.uploadCount = allFiles.length * 10;
        
        for (let file of allFiles) {
            // get the file size in bytes
            const sizeInBytes = file['size'];
            let bytesres = this.formatBytes(sizeInBytes);

            let imageData = {};
            imageData['src'] = URL.createObjectURL(file);
            if (file.type.includes('video/')) {
                imageData['file'] = file;
                imageData['type'] = 'video';
            } else {
                imageData['file'] = file;
                imageData['type'] = 'image';
            }
            imageData['id'] = null;
            imageData['value'] = '';
            imageData['isedit'] = false;
            imageData['isDokaConverted'] = false;
            if (index === 0 && !this.state.media.image.value.length)
                imageData['isdisplayimage'] = 1;
            if (!file.type.includes('video/')) {
                try {
                    this.progresseLabel = `Uploading media files ...`;
                    
                    let processImg = true;
                    let compressImg = true;
    
                    const mimetype = await FileType.fromBlob(file);
    
                    if (mimetype?.ext === 'heic') {
    
                        if (mimetype?.mime === 'image/heic') {
                            if (bytesres['size'] > 5) {
                                processImg = false;
                                this.largeFiles.push(imageData?.file?.name);
                                this.setState({
                                    itemStatus: { show: true, type: 'danger', message: 'The following images failed to upload because they were too big, the maximum size is 5MB.' }
                                });
                            } else {
                                imageData['setDummyImage'] = true;
                                compressImg = false;
                            }
                        } else {
                            // Let's turn the HEIC image into JPEG so the browser can read it
                            const blob =  await heic2any({
                                blob: file,
                                toType: 'image/jpeg'
                            });
    
                            file = blobToFile(blob, file.name);
    
                            imageData['src'] = URL.createObjectURL(file);
                        }
                    }
    
                    if (processImg) {
                        if (compressImg && bytesres['size'] > 1) {
                            let IMAGE_OUTPUT_QUALITY = 5; // in MB
                            if (bytesres['size'] > 1 && bytesres['size'] < 20){
                                IMAGE_OUTPUT_QUALITY = 1;
                            } else if(bytesres['size'] > 20 && bytesres['size'] < 50){
                                IMAGE_OUTPUT_QUALITY = 2;
                            } else if(bytesres['size'] > 50 && bytesres['size'] < 100){
                                IMAGE_OUTPUT_QUALITY = 3;
                            } else {
                                IMAGE_OUTPUT_QUALITY = 4;
                            }
        
                            const convertOptions = {
                                maxSizeMB: IMAGE_OUTPUT_QUALITY,
                                maxWidthOrHeight: 1920,
                                useWebWorker: true
                            }
        
                            const compressedFile = await imageCompression(file, convertOptions);
                            const convertedImageFile = blobToFile(compressedFile, file.name);
                            imageData['src'] = URL.createObjectURL(convertedImageFile); // updating converted image
                            imageData['file'] = {"dest": convertedImageFile, "src": convertedImageFile};
                        } else {
                            imageData['file'] = {"dest": file, "src": file};
                        }
                        imageValue.push(imageData);
                        bytesres = 0;
                    }                
                } catch (error) {
                    this.largeFiles.push(imageData?.file?.name);
                    this.setState({ 
                        itemStatus: {
                            ...this.state.itemStatus,
                            show:  true,
                            type: "danger",
                            message: "The assets listed below failed during uploading or compressing."
                        }
                    })
                }
                ++progressCount;
                this.percentage = (100 * progressCount) / fileCount;
            } else if (file.type.includes('video/')) {
                imageValue.push(imageData);
            }
            else {
                if (!file.type.includes('video/')) {
                    --fileCount
                    this.largeFiles.push(imageData?.file?.name); 
                }
            }
            if(progressCount == fileCount){
                this.uploadCount = 0;
            }
            ++index;
            this.setState({
                media: {
                    ...this.state.media,
                    image: {
                        ...this.state.media.image,
                        value: imageValue,
                        tempValue: imageValue
                    },
                    enableSave: false
                }
            
            });
        }
        if(this.state.itemTypeError){
            this.setState({
                itemStatus: { show: true, type: 'danger', message: this.state.itemTypeError ? "Onsite auction items are limited to Pickup Only. Please adjust your IRM settings to include Pickup." : ''  }
            });
        }
        event.target.value = '';
    }

    /*set image after doka edit */
    setImage = (output) => {
        let imageValue = this.state.media.image.value;
        imageValue[this.editImageIndex]['src'] = URL.createObjectURL(output.dest);
        const file = output.dest;
        let render = new FileReader();
        render.onloadend = () => {
            const base64String = render.result.replace('data:', '').replace(/^.+,/, '');
            imageValue[this.editImageIndex]['value'] = base64String;
            imageValue[this.editImageIndex]['isedit'] = true;
            imageValue[this.editImageIndex]['isDokaConverted'] = true;
            this.setState({
                ...this.state,
                media: {
                    ...this.state.media,
                    image: { ...this.state.media.image, value: imageValue, tempValue: imageValue },
                    modal: false,
                    temImg: null
                },
                enableSave: false
            })
        };

        render.readAsDataURL(file);
    }

    /* called when canceling doka editing */
    cancelImage = () => this.setState({
        ...this.state,
        media: {
            ...this.state.media,
            modal: false,
            temImg: null
        },
        enableSave: false
    });
    dragOver = (e) => {
        e.preventDefault();
    }

    dragEnter = (e) => {
        e.preventDefault();
    }

    dragLeave = (e) => {
        e.preventDefault();
    }

    reorderImages = (value) => {
        this.largeFiles =[];
        this.setState({
            isEdit: true,
            itemStatus: { show: false, type: '', message: '' }
        });
        if (Object.keys(value).includes('errorMessage')) {
            this.setState({
                itemStatus: { show: true, type: 'danger', message: value['errorMessage'] }
            }, () => {
                setTimeout(() => {
                    this.setState({
                        itemStatus: { show: false, type: '', message: '' }
                    });
                }, 1000);
            });
        }
        else {
            this.reorderImageIds = value['imageIds'].sort();
            value['images'].forEach((img) => {
                img['isdisplayimage'] = 0;
            })
            value['images'][0]['isdisplayimage'] = 1;
            this.setState({
                media: {
                    ...this.state.media,
                    image: {
                        ...this.state.media.image,
                        value: value['images'],
                        tempValue: value['images']
                    },
                    enableSave: false
                }
            });
        }
    }
    handleKeyDown = (event) => {
        const char = event.key;
        const controlKeys = [
            "Backspace",
            "Delete",
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Tab"
          ];
          if (controlKeys.includes(event.key)) {
            return; // allow navigation/edit keys
          }
        if (!quillAllowedRegexPattern.test(char)) {
          event.preventDefault();
        }
    };
      
      templateChange = (value) => {
        this.templateEditValue = value;
        this.forceUpdate()
        this.setState({isEdit: true});   
    }

    /* set template data */
    saveTemplateChange = () => {
        this.setState({
            ...this.state,
            detail: {
                ...this.state.detail,
                [this.editModalName]: {
                    ...this.state.detail[this.editModalName],
                    value: this.templateEditValue,
                    valid: this.templateEditValue ? this.templateEditValue === "<p><br></p>" ? false : true : false,
                },
                editModal: false
            }
        }, () => {
            this.templateEditValue = '';
        })
    }
    /* show template view */
    showViewModal = (modalName) => {
        this.viewModalName = modalName;
        this.setState({
            ...this.state,
            detail: {
                ...this.state.detail,
                viewModal: true
            }
        })
    }
    /* show template edit */
    showEditModal = (modalName) => {
        this.editModalName = modalName;
        this.templateEditValue = this.state.detail[modalName].value
        this.setState({
            ...this.state,
            detail: {
                ...this.state.detail,
                editModal: true
            }
        })
    }

    toggleVideoModal = (index) => {
        this.setState({
            media: {
                ...this.state.media,
                video: {
                    ...this.state.media.video,
                    modal: index
                }
            }
        });
    };
    textEditorOnShow = (event) => {
        this.textEditorRef.focus();
    }

    navigateToList = () => {
        const state = this.props.location.state;
        if (state)
            delete state['prevPath'];
        this.props.history.push({ pathname: this.state.prevPath, state: state, itemid: this.state.itemid, itemEdit: this.state.isitemEdit });
    };

    navigateTobackList = () => {
        if(this.state.isEdit){
            this.setState({
                backModal: true
            }) 

        }
        else{
            const state = this.props.location.state;
            if (state)
                delete state['prevPath'];
            this.props.history.push({ pathname: this.state.prevPath, state: state, itemid: this.state.itemid, itemEdit: this.state.isitemEdit });
        }
    };
    goBack = ()=>{
        const state = this.props.location.state;
        if (state)
            delete state['prevPath'];
        this.props.history.push({ pathname: this.state.prevPath, state: state, itemid: this.state.itemid, itemEdit: this.state.isitemEdit });
    }
    
    async getSecretKey(){
       await axios.get(getSellerUrl(`${secret_key}`),getSellerHeaders()).then(
            response => {
                if (response.data.status.toLowerCase() === 'success') {
                    this.setState({
                        buyerToken: response.data.accessToken
                    }, async() => {
                       await this.getBidHistory(response.data.accessToken)
                        this.getCategoryAreaMapList();
                        this.getLocationCategoryList();
                        this.getConditionData();
                    })
                }
            }).catch(error => {
                    this.setState({
                        secretKey:"",
                    })
                    if(error.response?.status == 401 || error.response?.status == 404) {
                        this.setState({
                            errorpageredirect: true,
                            errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                        })
                    }                 
                }
            );
    }
    getBidHistory=async(token)=> {
        await axios.get(getBuyerUrl(`${bid_history}/${this.itemId}`), getBuyerHeaders(token)).then(
            response => {
                if (response.data.data.bidhistory.length > 0) {
                    this.setState({
                        bidderCount: Array.from(new Set(response.data.data.bidhistory.map(elem => elem['buyerid']))).length,
                        bid_history: response.data.data.bidhistory,
                        currentBid: response.data.data.bidhistory[0]["bidprice"],
                     },()=> {                       
                        this.setState({
                            pageLoading: false
                        });
                    })                  
                }
                else {
                    this.setState({
                        bidderCount: 0,
                        bid_history: [],
                        currentBid: 0,
                        pageLoading: false
                    });
                }
            }
        ).catch(
            error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    ...this.state,
                    bidderCount: 0,
                    bid_history: [],
                    currentBid: 0,
                    pageLoading: false,
                })
            }
        );
    }

    searchSaleList = (value) => {
        this.setState({
            searchInput: value
        }, () => {
            let saleValue = null;
            let filter = [
                { op: "=", join: "AND", value: this.state.detail.locationid.value, field: "locationid" },
                { op: "LIKE", join: "AND", value: `%${value}%`, field: "title" },
                { field: 'status', value: 'Closed', op: '!=', join: 'AND' },
            ];
            axios.post(getSellerUrl(salelist), JSON.stringify({ filter: filter, field: ['id', 'title', 'tax', 'buyerspremium'] }), getSellerHeaders())
                .then(response => {
                    if (response.status === 200) {
                        this.sales = response.data.data;
                        let appendTemp = response.data.data;
                        if (this.selectedSale.length > 0) {
                            const deleteIndex = appendTemp.findIndex(x => x.id === this.selectedSale[0].id);
                            if (deleteIndex === -1) {
                                appendTemp = appendTemp.concat(this.selectedSale);
                            } else {
                                appendTemp.splice(deleteIndex, 1);
                            }
                        }
                        const temp = ArrayValueReorder(appendTemp, 'title');

                        this.setState({
                            ...this.state,
                            sales: temp,
                            formLoading: false,
                        });
                    }
                })
                .catch(error => {
                    let saleError = '';
                    if (error.response.status === 404) {
                        this.sales = [];
                        saleError = 'sale not available'

                    }
                    // else {
                    //     toast.error(error.response.data['message']);
                    // }
                    this.setState({
                        ...this.state,
                        formLoading: false,
                        detail: {
                            ...this.state.detail,
                            saleid: {
                                ...this.state.detail.saleid,
                                value: saleValue,
                                error: saleError
                            }
                        },
                        itemStatus: { show: saleError ? false : true, type: saleError ? '' : 'danger', message: saleError ? '' : error.response.data['message'] }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                itemStatus: { show: saleError ? false : true, type: saleError ? '' : 'danger', message: saleError ? '' : error.response.data['message'] }
                            })
                        }, 3000);
                    });
                });
        });
    }

    saleSelect = (sale) => {
        if (this.state.detail.saleid.value !== sale.id) {
            this.selectedSale.length === 0 ? this.selectedSale.push(sale) : this.selectedSale[0] = JSON.parse(JSON.stringify(sale));
            this.setState({
                searchInput: null,
                tempSale: JSON.parse(JSON.stringify(this.selectedSale)),
                sales: JSON.parse(JSON.stringify(this.selectedSale)),
                // detail: {
                //     saleid: {
                //         ...this.state.detail.saleid,
                //         value: sale.id,
                //         valid: true
                //     }
                // },
            }, () => {
                const event = {
                    "target": {
                        "name": "saleid",
                        "value": sale.id
                    }
                };
                this.generateSKU(sale.id);
                this.inputChange(event);
            });
        }
    }

    toggleSearchBox = (event) => {
        setTimeout(() => {
            const searchInput = JSON.parse(JSON.stringify(this.state.searchInput));
            this.setState({
                showSearchBox: event,
                searchInput: null,
                sales: searchInput ? this.selectedSale : this.state.sales
            });
        }, event ? 500 : 200);
    }
        
    getConditionData = () => {
        axios.get(getSellerUrl(conditionData), getSellerHeaders()).then(
            response => {
                this.setState({
                    conditionData: response.data.data
                })
            }
        )
    }

    onchangeShippingSpeciality = (event) => {
        let eventValue = event.target.checked;
        this.setState({
            settings: {
                ...this.state.settings,
                specialtyshippeditems: {
                    ...this.state.settings.specialtyshippeditems,
                    value: eventValue
                }
            }
        })
    }

    render() {
        if (this.state.errorpageredirect) {
            // redirect to Not-Found if wrong Itemid
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div id="scroller" style={{ overflow: "auto", overflowY: "overlay", overflowX: "hidden" }}>
                
                <div id="backbutton" style={{ borderBottom: "1px solid #b6b6b6", padding: "1%" }}>
                    <span onClick={() => this.navigateTobackList()} className="clickable">
                        <i className="fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i>
                        <span style={{ paddingLeft: "1em" }}>Back</span>
                    </span>
                    <span style={{ marginLeft: "0.5em", paddingLeft: "1em", borderLeft: "1px solid", color: "#A12142" }}>{this.edit ? 'Create New Item' : 'Item Edit'}</span>
                </div>
                <div className="itemEditHead itemEdit" >
                    <ul className="d-flex container">
                        <li className="stepper"><Button className={this.state.currentPage === 1 ? "active" : ''} disabled={this.state.currentPage === 1 || !this.edit ? false : true} onClick={() => this.setStep(1)}><span className="numberCount">1</span>Detail</Button></li>
                        <li className="stepper"><Button className={this.state.currentPage === 2 ? "active" : ''} disabled={this.state.currentPage === 2 || !this.edit ? false : true} onClick={() => this.setStep(2)}><span className="numberCount">2</span>Settings</Button></li>
                        <li className="stepper"><Button className={this.state.currentPage === 3 ? "active" : ''} disabled={this.state.currentPage === 3 || !this.edit ? false : true} onClick={() => this.setStep(3)}><span className="numberCount">3</span>Media</Button></li>
                    </ul>
                </div>
                {this.state.currentPage !== 3 &&
                    <div className="itemEdit">
                        {/* <ul className="d-flex container">
                            <li><Button className={this.state.currentPage === 1 ? "active" : ''} disabled={this.state.currentPage === 1 || !this.edit ? false : true} onClick={() => this.setStep(1)}><span className="numberCount">1</span>Detail</Button></li>
                            <li><Button className={this.state.currentPage === 2 ? "active" : ''} disabled={this.state.currentPage === 2 || !this.edit ? false : true} onClick={() => this.setStep(2)}><span className="numberCount">2</span>Settings</Button></li>
                            <li><Button className={this.state.currentPage === 3 ? "active" : ''} disabled={this.state.currentPage === 3 || !this.edit ? false : true} onClick={() => this.setStep(3)}><span className="numberCount">3</span>Media</Button></li>
                        </ul> */}
                        <Container className="itemEditContainer">
                            {this.state.formLoading ?
                                <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100" style={{ padding: "30%" }}>
                                    <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                                </div> :
                                <div>
                                    {this.state.currentPage === 1 &&
                                        <div className="itemForm">
                                            <h6><b>Item Details</b></h6>
                                            <Form>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.locationid.error && this.state.detail.locationid.error.length ? <small className="error">{this.state.detail.locationid.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control as="select" id="locationid" name="locationid" value={this.state.detail.locationid.value} className={this.state.detail.locationid.value ? 'form-control-active' : ''} placeholder=" " required onChange={(event) => this.inputChange(event)}>
                                                        <option selected disabled={ this.state.detail.locationid.value ? true : false }>Select Locations</option>
                                                        {this.locations.map((loc, index) =>
                                                            <option key={index} value={loc.id} disabled={(this.state.prevPath !== '/sales/items' && this.state.detail.locationid.value === loc.id) || this.state.prevPath === '/sales/items' ? false : true}>{loc.title}</option>
                                                        )}
                                                    </Form.Control>
                                                    <Form.Label htmlFor="locationid" className="required">Location</Form.Label>
                                                </div>
                                                <div className="my-2">
                                                    <Dropdown onToggle={(event) => this.toggleSearchBox(event)}>
                                                        <div className="custom-drop-down-label required">Sale</div>
                                                        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                            {this.state.detail.saleid.value ? this.state.sales.filter(x => x.id === this.state.detail.saleid.value).map(x => x.title) : "Select Sale"}
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu as={this.CustomMenu} className="custom-dropdown-menu" >

                                                            {this.state.sales.map(sale => {
                                                                return (
                                                                    <Dropdown.Item key={sale.id} eventKey={sale.id.toString()} onClick={() => this.saleSelect(sale)} active={this.state.detail.saleid.value === sale.id}>
                                                                        {sale.title}
                                                                    </Dropdown.Item>
                                                                );
                                                            })}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                    <div className="text">
                                                        {
                                                            this.state.detail.saleid.error && this.state.detail.saleid.error.length ? <small className="error" style={{ color: '#dc3545' }}>{this.state.detail.saleid.error}</small> : null
                                                        }
                                                    </div>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.category.error && this.state.detail.category.error.length ? <small className="error">{this.state.detail.category.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control as="select" id="category" name="category" value={this.state.detail.category.value} className={this.state.detail.category.value ? 'form-control-active' : ''} placeholder=" " required onChange={(event) => this.inputChange(event)}>
                                                        <option disabled={this.state.detail.category.value ? true : false} selected>Select Category</option>
                                                        {
                                                            this.category.map((item, index) =>
                                                                <optgroup key={index} label={item.category} style={{ backgroundColor: "#efefef" }}>
                                                                    {
                                                                        item.subcategory.length > 0 ?
                                                                            item.subcategory.map((subcategory, subIndex) =>
                                                                                <option key={index + subIndex} id={index + '#*#' + subIndex} value={item.category + '#*#' + subcategory.subcategory} style={{ backgroundColor: "white" }}>{subcategory.subcategory}</option>
                                                                            ) :
                                                                            <option key={index + 'no' + index} disabled style={{ backgroundColor: "white" }}>- - - - -</option>
                                                                    }
                                                                </optgroup>
                                                            )
                                                        }
                                                    </Form.Control>
                                                    <Form.Label htmlFor="category" className="required">Category</Form.Label>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.area.error && this.state.detail.area.error.length ? <small className="error">{this.state.detail.area.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control as="select" id="area" name="area" value={this.state.detail.area.value} className={this.state.detail.area.value ? 'form-control-active' : ''} placeholder=" " onChange={(event) => this.inputChange(event)}>
                                                        <option value=''>Select Area</option>
                                                        {AREA.map((area, index) =>
                                                            <option key={index} value={area}>{area}</option>
                                                        )}
                                                    </Form.Control>
                                                    <Form.Label htmlFor="area">Area</Form.Label>
                                                </div>
                                                <div className="d-flex">
                                                    <Button size="sm" className="textButton" onClick={() => { let title = allWordsInCaps(this.state.detail.title.value); this.setState({ ...this.state, detail: { ...this.state.detail, title: { ...this.state.detail.title, value: title } } }) }}>Aa</Button>

                                                    <div className="float-control" style={{ width: "100%" }}>
                                                        <div className="text">
                                                            {
                                                                this.state.detail.title.error && this.state.detail.title.error.length ? <small className="error">{this.state.detail.title.error}</small> : null
                                                            }
                                                        </div>
                                                        <Form.Control maxLength={100} as="textarea" id="title" name="title" value={this.state.detail.title.value} className={this.state.detail.title.value ? 'form-control-active' : ''} placeholder=" " onChange={(event) => this.inputChange(event)} />
                                                        <Form.Label htmlFor="title" className="required">Title</Form.Label>
                                                    </div>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.SKU.error && this.state.detail.SKU.error.length ? <small className="error">{this.state.detail.SKU.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="SKU" name="SKU" value={this.state.detail.SKU.value.toUpperCase()} className={this.state.detail.SKU.value ? 'form-control-active' : ''} placeholder=" " onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="SKU" className="required">Lot #(SKU)</Form.Label>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.condition.error && this.state.detail.condition.error.length ? <small className="error">{this.state.detail.condition.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control as="select" id="condition" name="condition" value={this.state.detail.condition.value} className={this.state.detail.condition.value ? 'form-control-active' : ''} placeholder=" " required onChange={(event) => this.inputChange(event)}>
                                                        <option selected value={''} disabled={this.state.detail.condition.value ? true : false } style={{backgroundColor: '#bfbfbf' , color:'white'}}>Select Item Condition</option>
                                                        {
                                                            this.state.conditionData.map(elem => {
                                                                return (
                                                                    <>
                                                                        <option value={elem.condition} style={{fontWeight:'bold', backgroundColor: '#e6e6e6'}}>{elem.condition} </option>
                                                                        <option disabled={true} style={{ wordBreak: 'break-word' }}>{elem.description}</option>
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </Form.Control>
                                                    <Form.Label htmlFor="condition" className="required">Condition</Form.Label>
                                                </div>
                                                    <div className="text">
                                                        {
                                                            this.state.detail.description.error && this.state.detail.description.error.length ? <small className="error">{this.state.detail.description.error}</small> : null
                                                        }
                                                    </div>
                                                    <div >
                                                        <div style={{ margin: "3% 0 6%" }} >
                                                            <div className="d-flex" >
                                                                <div className="templateClass" style={{ width: "100%", border: this.state.detail.description.valid ? "1px solid #2b2b2b" : "solid #525252", borderRadius: "4px" }}>
                                                                    <Form.Label className="templateLabel" style={{ fontSize: "18px" }} htmlFor={"description"}>Description </Form.Label>
                                                                    <div style={{ overflow: "hidden overlay", margin: "-4% 0px 0px 2%", height: "60px", padding: "0" }} className="ql-editor" >{this.state.detail.description ? this.state.detail.description.value ?
                                                                        <div style={{ paddingRight: "4%" ,overflow:'auto'}} dangerouslySetInnerHTML={{ __html: this.state.detail.description.value }} /> : <p style={{ color: "#b3b1b1" }}>Click edit icon to add text</p> : ''}
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: "block", width: "5%", marginTop: "3%" }}>
                                                                    <div>
                                                                        <img src={`/static/icons/table/view.svg`} alt="view" height="25px" width="25px" className="action-button" onClick={() => this.showViewModal("description")} />
                                                                    </div>
                                                                    <div>
                                                                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/edit.svg`} alt="edit" height="25px" width="25px" className="action-button" onClick={() => this.showEditModal("description")} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="d-block text">
                                                                {
                                                                    this.state.detail.description.error && this.state.detail.description.error.length ? <small className="error text-danger">{this.state.detail.description.error}</small> : null
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                <div className="float-control" style={{ marginTop: '-15px' }}>
                                                    <div className="text">
                                                        {
                                                            this.state.detail.itemstatus.error && this.state.detail.itemstatus.error.length ? <small className="error">{this.state.detail.itemstatus.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control as="select" id="itemstatus" name="itemstatus" value={this.state.detail.itemstatus.value} className={this.state.detail.itemstatus.value ? 'form-control-active' : ''} placeholder=" " required onChange={(event) => this.inputChange(event)} disabled={["sold", "not sold"].includes(this.state.detail.itemstatus.value.toLowerCase()) || this.state.itemStatusValid}>
                                                        <option selected value={''} disabled={this.state.detail.itemstatus.value ? true : false }>Select Status</option>
                                                        <option value="Pending">Pending</option>
                                                        <option value="Ready">Ready</option>
                                                        {/* {!this.edit && <option value="Archived">Archived</option>} */}
                                                        {!this.edit && <option disabled={true} value="Not Sold">Not Sold</option>}
                                                        {!this.edit && <option disabled={true} value="Sold">Sold</option>}
                                                    </Form.Control>
                                                    <Form.Label htmlFor="itemstatus" className="required">Status</Form.Label>
                                                </div>

                                            </Form>
                                            <Modal id="itemDescription" show={this.state.detail.viewModal} size="xl" animation={false} onHide={() => { this.setState({ ...this.state }) }} keyboard={false}>
                                                <Modal.Body className="templateClass">
                                                    {
                                                        this.state.detail[this.viewModalName] ? this.state.detail[this.viewModalName].value ?

                                                        <div className="ql-editor" style={{ padding: "1rem", overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: this.state.detail[this.viewModalName].value }} />
                                                        : '' : ''
                                                    }
                                                </Modal.Body>
                                                <Modal.Footer className="justify-content-center">
                                                    <Button variant="secondary" onClick={() => this.setState({ ...this.state, detail: { ...this.state.detail, viewModal: false } })}>Close</Button>
                                                </Modal.Footer>
                                            </Modal>
                                            <Modal show={this.state.detail.editModal} size="lg" animation={false} onHide={() => this.setState({ ...this.state })} onShow={this.textEditorOnShow}>
                                                <Modal.Body className="templateClass">
                                                    <div className="text-editor">
                                                        <div className="wrapper">
                                                        <ReactQuill theme="snow" modules={this.modules} value={this.templateEditValue} onChange={this.templateChange} ref={(el) => this.textEditorRef = el} onKeyDown={this.handleKeyDown}/>

                                                        </div>
                                                    </div>
                                                    <div className="d-flex" style={{ margin: "1% 2%", float: "right" }}>
                                                        <Button style={{ marginRight: "4%" }} onClick={() => this.setState({ ...this.state, detail: { ...this.state.detail, editModal: false } })}>Cancel</Button>
                                                        <Button className="save-button" onClick={() => this.saveTemplateChange()}>Save</Button>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    }
                                    {this.state.currentPage === 2 &&
                                        <div className="itemForm">
                                            <h6><b>Item Settings</b></h6>
                                            <Form>
                                                <div className="d-flex my-3">
                                                    {/* <Form.Check inline type="checkbox" checked={this.state.settings.isshippable.value} name="isshippable" label="Item is shippable" id="isshippable" disabled={Number(this.state.settings.itemtypeid.value) === 3 ? true : false} onChange={(event) => this.inputChange(event)} /> */}
                                                    <Form.Check inline type="checkbox" checked={this.state.settings.isfeatured.value} name="isfeatured" label="Item is featured" id="isfeatured" onChange={(event) => this.inputChange(event)} />
                                                    <Form.Check style={{ marginRight: "0" }} inline type="checkbox" checked={this.state.settings.istaxable.value} name="istaxable" label="Item not taxable" id="istaxable" onChange={(event) => this.inputChange(event)} />
                                                </div>
                                                <div className="d-flex flex-column">
                                                    <label className="text-muted">Item Receipt Methods <span className="text-danger">*</span></label>
                                                </div>
                                                <div className="d-flex">
                                                    <Form.Check inline type="checkbox" checked={this.state.settings.itemreceiptmethod.value?.pickup} name="pickup" label="Pickup" id="ispickup" onChange={(event) => this.receiptCheckBox(event)} disabled={this.state.invalidIrm.includes('pickup')} />
                                                    <Form.Check inline type="checkbox" checked={this.state.settings.itemreceiptmethod.value?.delivery} name="delivery" label="Delivery" id="isdelivery" onChange={(event) => this.receiptCheckBox(event)} disabled={this.state.invalidIrm.includes('delivery')}/>
                                                    <Form.Check inline type="checkbox" checked={this.state.settings.itemreceiptmethod.value?.shipping} name="shipping" label="Shipping" id="isshipping" onChange={(event) => this.receiptCheckBox(event)} disabled={this.state.invalidIrm.includes('shipping')}/>
                                                </div>
                                                <div className="text">
                                                    {
                                                        this.state?.settings?.itemreceiptmethod?.error ? <small className="error text-danger">{this.state.settings?.itemreceiptmethod.error}</small> : null
                                                    }
                                                </div>
                                                
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.itemtypeid.error && this.state.settings.itemtypeid.error.length ? <small className="error">{this.state.settings.itemtypeid.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control as="select" id="itemtypeid" name="itemtypeid" value={this.state.settings.itemtypeid.value} className={this.state.settings.itemtypeid.value ? 'form-control-active' : ''} placeholder=" " required onChange={(event) => this.inputChange(event)}>
                                                        {/* <option style={{ display: "none" }}>Select Type</option> */}
                                                        <option value="2">Auction</option>
                                                        <option value="1" disabled={!this.state.showItemType}>Direct Buy</option>
                                                        <option value="3">Onsite</option>
                                                    </Form.Control>
                                                    <Form.Label htmlFor="itemtypeid" className="required">Item Type</Form.Label>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.startingprice.error && this.state.settings.startingprice.error.length ? <small className="error">{this.state.settings.startingprice.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="startingprice" name="startingprice" value={this.state.settings.startingprice.value} className={this.state.settings.startingprice.value ? 'form-control-active' : ''} placeholder=" " onChange={(event) => this.inputChange(event)} disabled />
                                                    <Form.Label htmlFor="startingprice" className={Number(this.state.settings.itemtypeid.value) !== 1 ? 'required' : ''}>Starting Price ($)</Form.Label>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.reserveprice.error && this.state.settings.reserveprice.error.length ? <small className="error">{this.state.settings.reserveprice.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="reserveprice" name="reserveprice" value={this.state.settings.reserveprice.value} className={this.state.settings.reserveprice.value ? 'form-control-active' : ''} disabled={Number(this.state.settings.itemtypeid.value) === 1 || Number(this.state.settings.itemtypeid.value) === 3 ? true : false} placeholder=" " onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="reserveprice">Reserve Price ($)</Form.Label>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.buynowprice.error && this.state.settings.buynowprice.error.length ? <small className="error">{this.state.settings.buynowprice.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="buynowprice" name="buynowprice" className={this.state.settings.buynowprice.value ? 'form-control-active' : ''} value={this.state.settings.buynowprice.value} disabled={Number(this.state.settings.itemtypeid.value) === 3 || !this.state.showItemType} placeholder=" " onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="buynowprice" className={Number(this.state.settings.itemtypeid.value) === 1 ? 'required' : ''}>Buy it now Price ($)</Form.Label>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.buyerspremium.error && this.state.settings.buyerspremium.error.length ? <small className="error">{this.state.settings.buyerspremium.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="buyerspremium" name="buyerspremium" className={this.state.settings.buyerspremium.value ? 'form-control-active' : ''} value={this.state.settings.buyerspremium.value} placeholder=" " onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="buyerspremium">Buyers Premium (%)</Form.Label>
                                                </div>
                                                <fieldset>
                                                    <legend>Dimensions & weight</legend>
                                                    <div className="d-flex dimensionWeight">
                                                         <div className="float-control dimension mar-lr">
                                                            <div className="text">
                                                                {
                                                                    this.state.settings.length.error && this.state.settings.length.error.length ? <small className="error" style={{ fontSize: "62%" }}>{this.state.settings.length.error}</small> : null
                                                                }
                                                            </div>

                                                            <Form.Control type="text" id="length" name="length" value={this.state.settings.length.value} className={this.state.settings.length.value ? 'form-control-active' : ''} placeholder="Inches" onChange={(event) => this.inputChange(event)} />
                                                            <Form.Label htmlFor="length">Length (inches)</Form.Label>
                                                        </div>
                                                        <div className="float-control dimension mar-lr">
                                                            <div className="text">
                                                                {
                                                                    this.state.settings.width.error && this.state.settings.width.error.length ? <small className="error" style={{ fontSize: "62%" }}>{this.state.settings.width.error}</small> : null
                                                                }
                                                            </div>

                                                            <Form.Control type="text" id="width" name="width" value={this.state.settings.width.value} className={this.state.settings.width.value ? 'form-control-active' : ''} placeholder="Inches" onChange={(event) => this.inputChange(event)} />
                                                            <Form.Label htmlFor="width">Width (inches)</Form.Label>
                                                        </div>
                                                        <div className="float-control dimension mar-lr">
                                                            <div className="text">
                                                                {
                                                                    this.state.settings.height.error && this.state.settings.height.error.length ? <small className="error" style={{ fontSize: "62%" }}>{this.state.settings.height.error}</small> : null
                                                                }
                                                            </div>

                                                            <Form.Control type="text" id="height" name="height" value={this.state.settings.height.value} className={this.state.settings.height.value ? 'form-control-active' : ''} placeholder="Inches" onChange={(event) => this.inputChange(event)} />
                                                            <Form.Label htmlFor="height">Height (inches)</Form.Label>
                                                        </div>
                                                        <div className="float-control dimension mar-lr">
                                                            <div className="text">
                                                                {
                                                                    this.state.settings.weight.error && this.state.settings.weight.error.length ? <small className="error" style={{ fontSize: "62%" }}>{this.state.settings.weight.error}</small> : null
                                                                }
                                                            </div>

                                                            <Form.Control type="text" id="weight" name="weight" value={this.state.settings.weight.value} className={this.state.settings.weight.value ? 'form-control-active' : ''} placeholder="lbs" onChange={(event) => this.inputChange(event)} />
                                                            <Form.Label htmlFor="weight" >Weight (lbs)</Form.Label>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.shippingfee.error && this.state.settings.shippingfee.error.length ? <small className="error">{this.state.settings.shippingfee.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="shippingfee" name="shippingfee" value={this.state.settings.shippingfee.value} className={this.state.settings.shippingfee.value ? 'form-control-active' : ''} placeholder=" " onChange={(event) => this.inputChange(event)} disabled={(this.state.settings.itemreceiptmethod.value?.pickup && !this.state.settings.itemreceiptmethod.value?.delivery  && !this.state.settings.itemreceiptmethod.value?.shipping) || this.state.itemTypeError}  />
                                                    <Form.Label htmlFor="shippingfee">Shipping ($)</Form.Label>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.handlingfee.error && this.state.settings.handlingfee.error.length ? <small className="error">{this.state.settings.handlingfee.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="handlingfee" name="handlingfee" value={this.state.settings.handlingfee.value} className={this.state.settings.handlingfee.value ? 'form-control-active' : ''} placeholder=" " onChange={(event) => this.inputChange(event)} disabled={(this.state.settings.itemreceiptmethod.value?.pickup && !this.state.settings.itemreceiptmethod.value?.delivery  && !this.state.settings.itemreceiptmethod.value?.shipping) || this.state.itemTypeError} />
                                                    <Form.Label htmlFor="handlingfee">Handling ($)</Form.Label>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.goal.error && this.state.settings.goal.error.length ? <small className="error">{this.state.settings.goal.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="goal" name="goal" value={this.state.settings.goal.value} className={this.state.settings.goal.value ? 'form-control-active' : ''} placeholder=" " onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="goal">Goal ($)</Form.Label>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.fragilityscore?.error && this.state.settings.fragilityscore?.error.length ? <small className="error">{this.state.settings.fragilityscore?.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control  size={6}  as="select" id="fragilityscore" name="fragilityscore" value={this.state.settings.fragilityscore?.value} className={`fragilityscore ${this.state.settings.fragilityscore.value ? 'form-control-active' : ''}`} placeholder=" " onChange={(event) => this.inputChange(event)}>
                                                        <option style={{ display: "none" }}>Select Fragility Score</option>
                                                        <option value="1" className='fragile-title'>Non Fragile</option>
                                                        <option disabled={true} >Items are robust and unlikely to break or damage easily during normal handling. These items can be packed with less care.</option>
                                                        <option value="2"  className='fragile-title'>Slightly Fragile</option>
                                                        <option disabled={true}>Items are generally durable, but have a slight risk of damage if dropped or mishandled. These items should be packed securely with protective materials.</option>
                                                        <option value="3"  className='fragile-title'>Moderately Fragile</option>
                                                        <option disabled={true} >Items are more susceptible to damage and require careful handling. Padding, cushioning, and proper bracing are essential.</option>
                                                        <option value="4"  className='fragile-title'>Fragile</option>
                                                        <option disabled={true} >Items are very delicate and prone to breakage or damage. They require extra protection and care during packing and shipping.</option>
                                                        <option value="5" className='fragile-title'>Very Fragile</option>
                                                        <option disabled={true}>Items are highly sensitive and require the utmost caution. Special packaging, bracing, and potentially additional support may be needed.</option>
                                                    </Form.Control>
                                                    <Form.Label htmlFor="fragilityscore">Fragility Score</Form.Label>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.valuation?.error && this.state.settings.valuation?.error.length ? <small className="error">{this.state.settings.valuation?.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="valuation" name="valuation" value={this.state.settings.valuation?.value} className={this.state.settings.valuation.value ? 'form-control-active' : ''} placeholder="What do you think this item is worth?" onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="valuation">Estimated Valuation ($)</Form.Label>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.quantity?.error && this.state.settings.quantity?.error.length ? <small className="error">{this.state.settings.quantity?.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="quantity" name="quantity" pattern="^[0-9]*$" value={this.state.settings.quantity?.value} placeholder="How many pieces are in this lot?" onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="quantity">Quantity</Form.Label>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.material?.error && this.state.settings.material?.error.length ? <small className="error">{this.state.settings.material?.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="material" name="material" value={this.state.settings.material?.value} placeholder="What material is this item made out of?" onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="material">Material</Form.Label>
                                                </div>
                                                <div className="d-flex flex-column">
                                                    <label className="text-muted">Speciality Shipped</label>
                                                </div>
                                                <div className="d-flex">
                                                    <Form.Check inline type="checkbox" checked={this.state.settings.specialtyshippeditems?.value} name="specialtyshippeditems" label="Specialty Shipped Items" id="specialtyshippeditems" onChange={(event) => this.onchangeShippingSpeciality(event)} />
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.tax.error && this.state.settings.tax.error.length ? <small className="error">{this.state.settings.tax.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="tax" name="tax" value={this.state.settings.tax.value} className={this.state.settings.tax.value ? 'form-control-active' : ''} placeholder=" " onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="tax" className={!this.state.settings.istaxable.value ? 'required' : ''}>Tax (%)</Form.Label>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.tag.error && this.state.settings.tag.error.length ? <small className="error">{this.state.settings.tag.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="tag" name="tag" placeholder=" " className={this.state.settings.tag.value.length ? 'form-control-active' : ''} onKeyDown={event => { if (event.key === 'Enter') { this.tagChange(event) } }} onChange={this.tagValueUpdate} />
                                                    <Form.Label htmlFor="tag">Tag (Press Enter to add Tag)</Form.Label>
                                                </div>
                                                <div>
                                                    <div className="tag-container">
                                                        <div style={{ display: "flex", flexWrap: "wrap" }} >
                                                            {this.state.settings.tag.value.map(data =>
                                                                <div className="items-tag-list">
                                                                    <span className="tag-value">{data}</span>
                                                                    <div className="tag-close-icon clickable" onClick={() => this.removeTag(data)}>
                                                                        <i className="fa fa-times" style={{ color: "#392e2e" }}></i>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Form>

                                        </div>
                                    }
                                    <div className="align-items-center justify-content-center mb-3 mt-4">
                                        <div id="toaster" className={this.state.itemStatus.show ? " d-flex flex-row align-items-center justify-content-center toaster" : ''} >
                                            {
                                                this.state.itemStatus.show ?
                                                    <ToasterMessage type={this.state.itemStatus.type} message={this.state.itemStatus.message} className="alert-handle"></ToasterMessage>
                                                    : null
                                            }
                                        </div>
                                        <div className="buttonGroup">
                                            {this.state.currentPage === 2 &&
                                                <Button style={{ float: "right", width: "auto" }} className="mx-1" onClick={() => this.setStep(1)}>Previous</Button>
                                            }
                                            <Button style={{ float: "right", width: "auto" }} className="mx-1" onClick={this.navigateToList}>Cancel</Button>
                                            <Button style={{ float: "left" }} className="save-button mx-1" disabled={(!this.state.disableButton && this.state.itemStatus.type !== 'success' && !this.state.loading ? false : true) || this.state.irmvalid} onClick={() => this.checkFieldValidations()}>{!this.edit ? 'Update' : ' '}{this.edit && this.state.currentPage === 1 ? 'Next' : ' '}{this.edit && this.state.currentPage === 2 ? 'Save' : ' '}{this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </Container>
                        <Modal centered show={this.state.showConfirmModal && !this.state.loading} className="confirmModal justify-content-center" onHide={() => this.setState({ ...this.state })}>
                            <Modal.Body className="p-4 text-center">
                                Do you want to add media to this item ?
                                <div className="d-flex flex-row justify-content-center mt-4">
                                    <Button className="btn-white mx-1" disabled={this.state.loading} onClick={() => this.submitForm(false)}> No, save & exit</Button>
                                    <Button className="save-button mx-1" disabled={this.state.loading} onClick={() => this.submitForm(true)}> Yes, add media</Button>

                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>}
                {this.state.currentPage === 3 &&
                    <div className="itemMediaEdit">
                        {/* <ul className="d-flex container">
                            <li><Button className={this.state.currentPage === 1 ? "active" : ''} disabled={this.state.currentPage === 1 || !this.edit ? false : true} onClick={() => this.setStep(1)}><span className="numberCount">1</span>Detail</Button></li>
                            <li><Button className={this.state.currentPage === 2 ? "active" : ''} disabled={this.state.currentPage === 2 || !this.edit ? false : true} onClick={() => this.setStep(2)}><span className="numberCount">2</span>Settings</Button></li>
                            <li><Button className={this.state.currentPage === 3 ? "active" : ''} disabled={this.state.currentPage === 3 || !this.edit ? false : true} onClick={() => this.setStep(3)}><span className="numberCount">3</span>Media</Button></li>
                        </ul> */}
                        <Container className="itemEditContainer">
                        
                            {this.state.formLoading ?
                                <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100" style={{ padding: "30%" }}>
                                    <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                                </div> :
                                <div>

                                    {this.state.currentPage === 3 &&
                                        <div className="mediaItem">
                                            <h6><b>Media Library</b></h6>
                                            <div style={{ backgroundColor: "#fff" }}>
                                                <div className="mediaUpload" onDragOver={this.dragOver} onDragEnter={this.dragEnter} onDragLeave={this.dragLeave} onDrop={this.changeImage}>
                                                    <h5>Drop Images here</h5><h6 style={{ color: "#878787", marginBottom: "2%" }} className="my-3">or</h6>
                                                    <Form.Control multiple id="image" name="image" type="file" onChange={this.changeImage} accept={`${IMAGE_TYPES}, ${VIDEO_TYPES}`} hidden />
                                                    <Button variant="secondary" className="uploadButton" onClick={this.uploadImage} disabled={(this.totalMediaAllowed - this.state.media.image.value.length) == 0}>Upload Image</Button>
                                                    <h6 style={{ color: "#878787" }} className="my-3">You can upload maximum of {this.totalMediaAllowed - this.state.media.image.value.length} Image(s) / Video(s) per item</h6>
                                                </div>
                                        
                                                <div>
                                                    <div style={{ margin: "1% 3% 0" }}>
                                                        <Row xs={2} md={2} style={{ paddingBottom: this.state.media.image.value.length ? '' : '1%' }} >
                                                            <Col>{this.state.media.image.value.length ?
                                                                <p style={{ color: "secondary", margin: "auto", marginLeft: "4%" }}>Display Image<br></br><span style={{ marginLeft: "10%" }}><i className="fas fa-caret-down fa-lg"></i></span></p>
                                                                : ''}
                                                            </Col>
                                                            <Col >
                                                                {this.state.media.image.value.length ?
                                                                    <div>
                                                                        <Button size="sm" className="deleteButton" disabled={this.state.currentBid && this.state.currentBid!==0} onClick={() => { this.setState({ ...this.state, isEdit:true, media: { ...this.state.media, deleteAllImage: true } }) }}>Delete All</Button>
                                                                        <Modal centered show={this.state.media.deleteAllImage} size="sm" animation={false} keyboard={false} onHide={() => { this.setState({ ...this.state }) }}>
                                                                            <Modal.Body>
                                                                                <div className="d-flex flex-column justify-content-center align-items-center">
                                                                                    Are you sure to delete all images?
                                                                                    <div className="d-flex flex-row mt-4">
                                                                                        <Button variant="outline-dark btn-white mx-2" style={{ width: '60px' }} onClick={() => { this.setState({ media: { ...this.state.media, deleteAllImage: false } }) }}>No</Button>
                                                                                        <Button variant="secondary mx-2" style={{ width: '60px' }} onClick={() => this.deleteImage('all')}>Yes</Button>
                                                                                    </div>
                                                                                </div>
                                                                            </Modal.Body>
                                                                        </Modal>
                                                                    </div>
                                                                    : ''}
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <div style={{ display: "block", marginTop: "-1%" }}>
                                                        {/* <div className={window.outerWidth < 760 ? "d-inline" : "d-flex"} style={{ flexWrap: "wrap" }}>
                                                            {this.state.media.image.value.map(image =>
                                                                <div style={{ border: "1px solid", margin: "1% 2%" }}>
                                                                    <div className="mediaImage">
                                                                        <img src={`${process.env.PUBLIC_URL}/static/images/image_thumbnail.png`} alt="thumbnail image" height="135" width="135" />

                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div> */}
                                                        {
                                                            this.state.media.image.value.length > 0 && this.state.showReorder ?
                                                                <ReorderImages images={this.state.media.image.value} callback={(event) => { this.reorderImages(event) }} editImage={(event) => this.editImage(event.src)}
                                                                    deleteImage={(event) => { this.deleteImage(event.src) }} toggleVideoModal={this.toggleVideoModal} />
                                                                : !this.edit && this.state.media.image.imgCount === null &&
                                                                <div className="d-flex" style={{ flexWrap: "wrap" }}>
                                                                    <div style={{ border: "1px solid", margin: "1% 2%" }}>
                                                                        <div className="mediaImage">
                                                                            <img src={`${process.env.PUBLIC_URL}/static/images/image_thumbnail.png`} alt="thumbnail" height="135" width="135" />

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="align-items-center justify-content-center mb-3 mt-4">
                                        <div id="toaster" className={this.state.itemStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster" : ''}>
                                            {
                                                this.state.itemStatus.show ?
                                                    <ToasterMessage type={this.state.itemStatus.type} message={this.state.itemStatus.message} className="alert-handle"></ToasterMessage>
                                                    : null

                                                    
                                            }
                                           
                                        </div>
                                        <div className="align-items-center justify-content-center mb-4 mt-1">
                                            <div class="d-flex flex-column align-items-center toaster">
                                                {
                                                this.largeFiles?.map((car) => (
                                                    <ToasterMessage type={this.state.itemStatus.type} message={car} className="alert-handle"></ToasterMessage>
                                                ))}
                                            </div>
                                        </div>  
                                      
                                         <div className="buttonGroup">
                                            <Button style={{ float: "right", width: "auto" }} className="mx-1" onClick={this.navigateToList}>Cancel</Button>
                                            <Button style={{ float: "left" }} className="save-button" disabled={((this.edit && this.state.media.image.value.length && !this.state.loading) || this.state.irmValid || (!this.edit && !this.state.loading && this.state.media.image.value.length) || (!this.state.loading && this.state.media.enableSave)) && this.state.itemStatus.type !== 'success' ? false : true} onClick={() => this.checkFieldValidations(true)}>Save {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </Container>
                    </div>}
                <Modal show={this.state.media.modal} size="md" animation={false} onHide={() => this.setState({ ...this.state })}>
                    <Modal.Header>
                        <Button type="button" onClick={this.cancelImage} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                    </Modal.Header>
                    <Modal.Body className="doka d-flex flex-column align-items-center justify-content-center">
                        <div className="doka-profile-layout" style={{ width: '100%' }}>
                        <PinturaEditor {...getEditorDefaults()}
                                {...this.customEditorDefaults} src={this.state.media.temImg}
                                onProcess={this.setImage} />
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.media.video.modal > -1} size="md" animation={false} onHide={() => this.setState({ ...this.state })}>
                    <Modal.Header>
                        <Button type="button" onClick={() => this.toggleVideoModal(-1)} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center">
                        <div style={{ width: '400px', height: '400px' }}>
                            {
                                this.state.media.image.value.length && this.state.media.video.modal > -1 ?
                                    <video disablePictureInPicture src={this.state.media.image.value[this.state.media.video.modal]['src']} controls
                                        autoPlay="autoplay" style={{ width: '100%', height: '100%' }}></video> :
                                    null
                            }
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.uploadCount !== 0} size="md" animation={false} onHide={() => { this.setState({ ...this.state }) }}>
                <Modal.Header>
                      {<h6>Uploading media files ...</h6>} 
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center">
                        <div className="progressBar" id="progressBar" style={{ width: '100%' }}>
                            <ProgressBar id="progressBarimg"  variant="success" animated now={this.percentage} min={0} max={100} label={this.percentage.toFixed() +' %'}  />
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.showItemStatusErrorModel} size="md" animation={false} >
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center">
                        <div>
                           <div className='text-center'>The Sale End Date has already passed. Please adjust the End Date to a future date before changing the item status.</div>
                            <div className='d-flex align-items-center justify-content-center mt-4'>
                                <Button className="btn-secondary mx-1" onClick={() => { this.setState({ ...this.state, showItemStatusErrorModel: false }) }}>Cancel</Button>
                            </div>
                        </div>
                        
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.openMediaDialogModal} size="md" animation={false} >
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center">
                        {
                            this.state.dialogModalMessage ? 
                                <div>
                                    <div id="toaster" className={this.state.modalMessage.show ? "d-flex flex-row align-items-center justify-content-center toaster" : ''}>
                                        {
                                            this.state.modalMessage.show ?
                                                <ToasterMessage type={this.state.modalMessage.type} message={this.state.modalMessage.message} className="alert-handle"></ToasterMessage>
                                                : null       
                                        }
                                        
                                    </div>
                                    <div className='d-flex flex-column align-items-center toaster'>
                                        {
                                            this.errorFileList.map((elem) => (
                                                <ToasterMessage type={this.state.modalMessage.type} message={elem} className="alert-handle"></ToasterMessage>
                                            ))
                                        }
                                    </div>
                                    <div className='d-flex align-items-center justify-content-center'>
                                        <Button className="btn-secondary mx-1" onClick={() => { this.navigateToList() }}>Close</Button>
                                    </div>
                                </div>
                                 :
                                <div className='d-flex align-items-center flex-column'>
                                    <h6 style={{ fontWeight: "bold", color: "#A50050" }}>Media upload in Progress <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />, </h6>
                                    <div style={{ fontWeight: "bold", color: "#A50050", fontSize: "small" }}>Please don't refresh browser or click back button.</div>
                                </div>
                        }
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.backModal}  size="md" animation={false} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Body >
                        <p style={{textAlign: 'center'}}>Your work will not be saved. Are you sure you want to go back?</p>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <Button variant="secondary" style={{backgroundColor: 'green', border: 'none'}} onClick={() => this.goBack()}> Yes, go back</Button>
                        <Button variant="secondary" onClick={() => this.setState({ ...this.state, backModal: false })}>No, stay on page</Button>
                    </Modal.Footer>
                </Modal>
               {/* CheckPoint Question Modal UI */}
               {/* { this.edit &&
                    <Modal centered show={this.state.checkPointModal} className="confirmModal justify-content-center" onHide={() => this.setState({ ...this.state })}>
                        <Modal.Body className="p-4 text-center">
                        <h6 style={{ textAlign: "center", margin: "5% 0%", color: "black", fontWeight: "-moz-initial" }}>{`Staff CheckPoint question:`}<h6 style={{ fontWeight: "bolder" }}>{`${this.state.checkPointMessage}`}</h6></h6>
                            { this.state.itemCheckStatus.show && 
                                <div class="d-flex flex-column align-items-center toaster">
                                    <ToasterMessage type={this.state.itemCheckStatus.type} message={this.state.itemCheckStatus.message} className="alert-handle"></ToasterMessage>
                                </div>
                            }
                            <div className="d-flex flex-row justify-content-center mt-4">
                                <Button className="btn-white mx-1" disabled={this.state.loading} onClick={() => { this.cancelCheckPoint() }}> No</Button>
                                <Button className="save-button mx-1" disabled={this.state.loading} onClick={() => { this.setState({ showConfirmModal: true ,checkPointModal: false })}}> Yes</Button>
                            </div>
                        </Modal.Body>
                    </Modal>
                } */}
            </div>
        );
    }
}